/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * WEG
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

export interface Country {
  /** @nullable */
  isocode?: string | null;
}

export interface Region {
  /** @nullable */
  isocode?: string | null;
}

export interface Address {
  country?: Country;
  defaultAddress?: boolean;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  line1?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  postalCode?: string | null;
  region?: Region;
}

export interface ConvertTokenInput {
  /** @nullable */
  jwt?: string | null;
  /** @nullable */
  easyToken?: string | null;
}

export interface Countries {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface Districts {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface ValueList {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface FromToBaseMotorCharacteristics {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  valueList?: ValueList[] | null;
}

export interface FromToCharacteristic {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  valueList?: ValueList[] | null;
}

export interface FromToMotorCharacteristics {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  valueList?: ValueList[] | null;
}

export interface GeoPoint {
  latitude?: number;
  longitude?: number;
}

export interface LanguageCodeClass {
  /** @nullable */
  languageCode: string | null;
}

export interface MailRequest {
  /** @nullable */
  toEmails?: string[] | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  body?: string | null;
  isHtmlBody?: boolean;
  /** @nullable */
  attachments?: string[] | null;
}

export interface NeedHelp {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  eMail?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  recaptchaToken?: string | null;
  /** @nullable */
  language?: string | null;
}

export interface NotSyncedEasyProductList {
  /** @nullable */
  applicationProductId?: string | null;
  /** @nullable */
  exceptionMessage?: string | null;
}

export interface PointsOfService {
  /** @nullable */
  label?: string | null;
  address?: Address;
  /** @nullable */
  displayName?: string | null;
  geoPoint?: GeoPoint;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  type?: string | null;
}

export interface ProblemDetails {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  [key: string]: unknown;
}

export interface Products {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface Regions {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface ReturnedString {
  /** @nullable */
  string?: string | null;
}

export interface SessionExpired {
  isNewSession?: boolean;
}

export interface Towns {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface VMEasyProductList {
  /** @nullable */
  applicationProductId?: string | null;
  /** @nullable */
  customId?: string | null;
  /** @nullable */
  application?: string | null;
  /** @nullable */
  baseConfigurable?: string | null;
  /** @nullable */
  entryNumber?: string | null;
  /** @nullable */
  exceptionMessage?: string | null;
  /** @nullable */
  fromToCharacteristics?: FromToCharacteristic[] | null;
  /** @nullable */
  fromToMotorCharacteristics?: FromToMotorCharacteristics[] | null;
  /** @nullable */
  fromToBaseMotorCharacteristics?: FromToBaseMotorCharacteristics[] | null;
}

export interface VM3PQToEasySynchronization {
  /** @nullable */
  cartId?: string | null;
  /** @nullable */
  catalog?: string | null;
  /** @nullable */
  hatUser?: string | null;
  /** @nullable */
  origin?: string | null;
  /** @nullable */
  purchaseCountry?: string | null;
  /** @nullable */
  quotationCode?: string | null;
  /** @nullable */
  quotationRevision?: string | null;
  /** @nullable */
  siteLanguage?: string | null;
  /** @nullable */
  sourceSystem?: string | null;
  /** @nullable */
  user?: string | null;
  /** @nullable */
  productList?: VMEasyProductList[] | null;
}

export interface VMAddress {
  /** @nullable */
  street?: string | null;
  /** @nullable */
  streetNr?: string | null;
  /** @nullable */
  zipCode?: string | null;
  /** @nullable */
  city?: string | null;
}

export interface VMAskForQuotationEmail {
  /** @nullable */
  language?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  town?: string | null;
  /** @nullable */
  district?: string | null;
}

export interface VMAskForQuotation {
  /** @nullable */
  eMail?: string | null;
  /** @nullable */
  userName?: string | null;
  /** @nullable */
  companyName?: string | null;
  address?: VMAddress;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  emails?: string[] | null;
  model?: VMAskForQuotationEmail;
  /** @nullable */
  recaptchaToken?: string | null;
  /** @nullable */
  language?: string | null;
}

export interface VMPropertiesEmbeddedPost {
  /** @minLength 1 */
  identifier: string;
  /** @nullable */
  referenceIdentifier?: string | null;
  /** @nullable */
  value?: string | null;
  /** @nullable */
  dataTypeId?: string | null;
}

export interface VMPropertySetsEmbeddedPost {
  /** @minLength 1 */
  identifier: string;
  /** @nullable */
  referenceIdentifier?: string | null;
  /** @nullable */
  properties?: VMPropertiesEmbeddedPost[] | null;
}

export interface VMAttachmentsEmbeddedPost {
  /** @nullable */
  fileAsBytes?: string | null;
  /** @minLength 1 */
  fileName: string;
  /** @nullable */
  typeId?: string | null;
  /** @nullable */
  categoryId?: string | null;
  /** @nullable */
  referenceIdentifier?: string | null;
  propertySet?: VMPropertySetsEmbeddedPost;
}

export interface VMAttachmentSetsEmbeddedPost {
  /** @nullable */
  attachments?: VMAttachmentsEmbeddedPost[] | null;
}

export interface VMDiscountsEmbeddedPost {
  value?: number;
  isPercentage?: boolean;
  /** @nullable */
  discountKindIdentifier?: string | null;
}

export interface VMEasyRedirect {
  /** @nullable */
  url?: string | null;
}

/**
 * @nullable
 */
export type VMEasySynchronizationResponseCpqErrorList = {
  [key: string]: string;
} | null;

export interface VMEasySynchronizationResponse {
  /** @nullable */
  returnUrl?: string | null;
  /** @nullable */
  returnLocation?: string | null;
  /** @nullable */
  syncedItems?: string[] | null;
  /** @nullable */
  cpqErrorList?: VMEasySynchronizationResponseCpqErrorList;
  /** @nullable */
  easyErrorList?: NotSyncedEasyProductList[] | null;
}

export interface VMImportLineItem {
  /** @nullable */
  lineItemIds?: string[] | null;
  /** @nullable */
  projectId?: string | null;
  overrideExisting?: boolean;
}

export interface VMInitiateSessionFromWebsite {
  /** @nullable */
  origin?: string | null;
  /** @nullable */
  purchaseCountry?: string | null;
  /** @nullable */
  catalog?: string | null;
  customer?: number;
  /** @nullable */
  customerName?: string | null;
  /** @nullable */
  language?: string | null;
  /** @nullable */
  productCategory?: string | null;
  /** @nullable */
  intermediateToken?: string | null;
}

export interface VMIsLoggedIn {
  isLoggedIn?: boolean;
}

export interface VMLineItemInformation {
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  customerId?: string | null;
  /** @nullable */
  priceIndicator?: string | null;
  /** @nullable */
  typeCode?: string | null;
}

export interface VMLineItemList {
  /** @nullable */
  lineItems?: string[] | null;
}

export interface VMQuotesPost {
  /** @nullable */
  identifier?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  referenceIdentifier?: string | null;
  /** @nullable */
  isOptional?: boolean | null;
  /** @nullable */
  rank?: number | null;
  /** @nullable */
  customer?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  propertySet?: VMPropertySetsEmbeddedPost;
  attachmentSet?: VMAttachmentSetsEmbeddedPost;
  /**
   * @deprecated
   * @nullable
   */
  markup?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  markupPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  serviceMarkup?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  serviceMarkupPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  discount?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  discountPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  serviceDiscount?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  serviceDiscountPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  bonusDiscount?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  bonusDiscountPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  projectDiscount?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  projectDiscountPercentage?: number | null;
  /** @nullable */
  discounts?: VMDiscountsEmbeddedPost[] | null;
  /** @nullable */
  opportunityId?: string | null;
  /** @nullable */
  statusId?: string | null;
  /** @nullable */
  quoteTypeId?: string | null;
  /** @nullable */
  currencyId?: string | null;
  /** @nullable */
  companyId?: string | null;
  /** @nullable */
  customerId?: string | null;
}

export interface VMWegStoreFinder {
  /** @nullable */
  countries?: Countries[] | null;
  /** @nullable */
  pointsOfService?: PointsOfService[] | null;
  /** @nullable */
  products?: Products[] | null;
  /** @nullable */
  regions?: Regions[] | null;
  /** @nullable */
  towns?: Towns[] | null;
  /** @nullable */
  districts?: Districts[] | null;
}

export interface WegTestCallInput {
  /** @nullable */
  domain?: string | null;
  /** @nullable */
  username?: string | null;
  /** @nullable */
  bearerToken?: string | null;
}

export type GetApiDownloadsDownloadDataSheetParams = {
  materialNumber?: string;
  country?: string;
  language?: string;
};

export type GetApiLineItemApiLineItemPropertiesParams = {
  lineItemId?: string;
};

export type PutApiLineItemApiLineItemPropertiesWithJsonParams = {
  lineItemId?: string;
};

export type PutApiLineItemApiLineItemPropertiesWithTextJsonParams = {
  lineItemId?: string;
};

export type PutApiLineItemApiLineItemPropertiesWithApplicationJsonParams = {
  lineItemId?: string;
};

export type PostApi3pqCpqV1LineitemsCloneIdParams = {
  cloneAttachments?: boolean;
  cloneProperties?: boolean;
  cloneComments?: boolean;
  cloneConfiguration?: boolean;
  cloneDeep?: boolean;
};

export type DeleteApiQuoteApiDeleteEmptyQuotesParams = {
  password?: string;
};

export type GetApi3pqCpqV1StatusIdParams = {
  languageId?: string[];
  start?: number;
  size?: number;
  sort?: string;
  order?: string;
  includes?: string;
  filter?: string;
};

export type GetApiTestSimulateErrorParams = {
  statusCode?: number;
};

export type postApiAskForQuotationAskForQuotationEmailWithJsonResponse200TextPlain =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailWithJsonResponse200ApplicationJson =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailWithJsonResponse200TextJson =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailWithJsonResponse500 = {
  data: void;
  status: 500;
};

export type postApiAskForQuotationAskForQuotationEmailWithJsonResponseSuccess =
  (
    | postApiAskForQuotationAskForQuotationEmailWithJsonResponse200TextPlain
    | postApiAskForQuotationAskForQuotationEmailWithJsonResponse200ApplicationJson
    | postApiAskForQuotationAskForQuotationEmailWithJsonResponse200TextJson
  ) & {
    headers: Headers;
  };
export type postApiAskForQuotationAskForQuotationEmailWithJsonResponseError =
  postApiAskForQuotationAskForQuotationEmailWithJsonResponse500 & {
    headers: Headers;
  };

export type postApiAskForQuotationAskForQuotationEmailWithJsonResponse =
  | postApiAskForQuotationAskForQuotationEmailWithJsonResponseSuccess
  | postApiAskForQuotationAskForQuotationEmailWithJsonResponseError;

export const getPostApiAskForQuotationAskForQuotationEmailWithJsonUrl = () => {
  return `/api/AskForQuotation/AskForQuotationEmail`;
};

export const postApiAskForQuotationAskForQuotationEmailWithJson = async (
  vMAskForQuotationEmail: VMAskForQuotationEmail,
  options?: RequestInit,
): Promise<postApiAskForQuotationAskForQuotationEmailWithJsonResponse> => {
  const res = await fetch(
    getPostApiAskForQuotationAskForQuotationEmailWithJsonUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(vMAskForQuotationEmail),
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiAskForQuotationAskForQuotationEmailWithJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiAskForQuotationAskForQuotationEmailWithJsonResponse;
};

export const getPostApiAskForQuotationAskForQuotationEmailWithJsonMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiAskForQuotationAskForQuotationEmailWithJson>
      >,
      TError,
      { data: VMAskForQuotationEmail },
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiAskForQuotationAskForQuotationEmailWithJson>
    >,
    TError,
    { data: VMAskForQuotationEmail },
    TContext
  > => {
    const mutationKey = ["postApiAskForQuotationAskForQuotationEmailWithJson"];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiAskForQuotationAskForQuotationEmailWithJson>
      >,
      { data: VMAskForQuotationEmail }
    > = (props) => {
      const { data } = props ?? {};

      return postApiAskForQuotationAskForQuotationEmailWithJson(
        data,
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiAskForQuotationAskForQuotationEmailWithJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiAskForQuotationAskForQuotationEmailWithJson>
    >
  >;
export type PostApiAskForQuotationAskForQuotationEmailWithJsonMutationBody =
  VMAskForQuotationEmail;
export type PostApiAskForQuotationAskForQuotationEmailWithJsonMutationError =
  void;

export const usePostApiAskForQuotationAskForQuotationEmailWithJson = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiAskForQuotationAskForQuotationEmailWithJson>
      >,
      TError,
      { data: VMAskForQuotationEmail },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiAskForQuotationAskForQuotationEmailWithJson>
  >,
  TError,
  { data: VMAskForQuotationEmail },
  TContext
> => {
  return useMutation(
    getPostApiAskForQuotationAskForQuotationEmailWithJsonMutationOptions(
      options,
    ),
    queryClient,
  );
};

export type postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse200TextPlain =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse200ApplicationJson =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse200TextJson =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse500 =
  {
    data: void;
    status: 500;
  };

export type postApiAskForQuotationAskForQuotationEmailWithTextJsonResponseSuccess =
  (
    | postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse200TextPlain
    | postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse200ApplicationJson
    | postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse200TextJson
  ) & {
    headers: Headers;
  };
export type postApiAskForQuotationAskForQuotationEmailWithTextJsonResponseError =
  postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse500 & {
    headers: Headers;
  };

export type postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse =
  | postApiAskForQuotationAskForQuotationEmailWithTextJsonResponseSuccess
  | postApiAskForQuotationAskForQuotationEmailWithTextJsonResponseError;

export const getPostApiAskForQuotationAskForQuotationEmailWithTextJsonUrl =
  () => {
    return `/api/AskForQuotation/AskForQuotationEmail`;
  };

export const postApiAskForQuotationAskForQuotationEmailWithTextJson = async (
  options?: RequestInit,
): Promise<postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse> => {
  const res = await fetch(
    getPostApiAskForQuotationAskForQuotationEmailWithTextJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiAskForQuotationAskForQuotationEmailWithTextJsonResponse;
};

export const getPostApiAskForQuotationAskForQuotationEmailWithTextJsonMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationAskForQuotationEmailWithTextJson
        >
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiAskForQuotationAskForQuotationEmailWithTextJson>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiAskForQuotationAskForQuotationEmailWithTextJson",
    ];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationAskForQuotationEmailWithTextJson
        >
      >,
      void
    > = () => {
      return postApiAskForQuotationAskForQuotationEmailWithTextJson(
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiAskForQuotationAskForQuotationEmailWithTextJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiAskForQuotationAskForQuotationEmailWithTextJson>
    >
  >;

export type PostApiAskForQuotationAskForQuotationEmailWithTextJsonMutationError =
  void;

export const usePostApiAskForQuotationAskForQuotationEmailWithTextJson = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationAskForQuotationEmailWithTextJson
        >
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiAskForQuotationAskForQuotationEmailWithTextJson>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiAskForQuotationAskForQuotationEmailWithTextJsonMutationOptions(
      options,
    ),
    queryClient,
  );
};

export type postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse200TextPlain =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse200ApplicationJson =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse200TextJson =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse500 =
  {
    data: void;
    status: 500;
  };

export type postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponseSuccess =
  (
    | postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse200TextPlain
    | postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse200ApplicationJson
    | postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse200TextJson
  ) & {
    headers: Headers;
  };
export type postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponseError =
  postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse500 & {
    headers: Headers;
  };

export type postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse =
  | postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponseSuccess
  | postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponseError;

export const getPostApiAskForQuotationAskForQuotationEmailWithApplicationJsonUrl =
  () => {
    return `/api/AskForQuotation/AskForQuotationEmail`;
  };

export const postApiAskForQuotationAskForQuotationEmailWithApplicationJson =
  async (
    options?: RequestInit,
  ): Promise<postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse> => {
    const res = await fetch(
      getPostApiAskForQuotationAskForQuotationEmailWithApplicationJsonUrl(),
      {
        ...options,
        method: "POST",
      },
    );

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse["data"] =
      body ? JSON.parse(body) : {};
    return {
      data,
      status: res.status,
      headers: res.headers,
    } as postApiAskForQuotationAskForQuotationEmailWithApplicationJsonResponse;
  };

export const getPostApiAskForQuotationAskForQuotationEmailWithApplicationJsonMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationAskForQuotationEmailWithApplicationJson
        >
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiAskForQuotationAskForQuotationEmailWithApplicationJson
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiAskForQuotationAskForQuotationEmailWithApplicationJson",
    ];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationAskForQuotationEmailWithApplicationJson
        >
      >,
      void
    > = () => {
      return postApiAskForQuotationAskForQuotationEmailWithApplicationJson(
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiAskForQuotationAskForQuotationEmailWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiAskForQuotationAskForQuotationEmailWithApplicationJson
      >
    >
  >;

export type PostApiAskForQuotationAskForQuotationEmailWithApplicationJsonMutationError =
  void;

export const usePostApiAskForQuotationAskForQuotationEmailWithApplicationJson =
  <TError = void, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof postApiAskForQuotationAskForQuotationEmailWithApplicationJson
          >
        >,
        TError,
        void,
        TContext
      >;
      fetch?: RequestInit;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof postApiAskForQuotationAskForQuotationEmailWithApplicationJson
      >
    >,
    TError,
    void,
    TContext
  > => {
    return useMutation(
      getPostApiAskForQuotationAskForQuotationEmailWithApplicationJsonMutationOptions(
        options,
      ),
      queryClient,
    );
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse200 =
  {
    data: void;
    status: 200;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponseSuccess =
  postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse200 & {
    headers: Headers;
  };
export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponseError =
  (
    | postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse400TextPlain
    | postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse400ApplicationJson
    | postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse400TextJson
    | postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse401TextPlain
    | postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse401ApplicationJson
    | postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse401TextJson
  ) & {
    headers: Headers;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse =
  | postApiAskForQuotationSendAskForQuotationEmailWithJsonResponseSuccess
  | postApiAskForQuotationSendAskForQuotationEmailWithJsonResponseError;

export const getPostApiAskForQuotationSendAskForQuotationEmailWithJsonUrl =
  () => {
    return `/api/AskForQuotation/SendAskForQuotationEmail`;
  };

export const postApiAskForQuotationSendAskForQuotationEmailWithJson = async (
  vMAskForQuotation: VMAskForQuotation,
  options?: RequestInit,
): Promise<postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse> => {
  const res = await fetch(
    getPostApiAskForQuotationSendAskForQuotationEmailWithJsonUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(vMAskForQuotation),
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiAskForQuotationSendAskForQuotationEmailWithJsonResponse;
};

export const getPostApiAskForQuotationSendAskForQuotationEmailWithJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationSendAskForQuotationEmailWithJson
        >
      >,
      TError,
      { data: VMAskForQuotation },
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiAskForQuotationSendAskForQuotationEmailWithJson>
    >,
    TError,
    { data: VMAskForQuotation },
    TContext
  > => {
    const mutationKey = [
      "postApiAskForQuotationSendAskForQuotationEmailWithJson",
    ];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationSendAskForQuotationEmailWithJson
        >
      >,
      { data: VMAskForQuotation }
    > = (props) => {
      const { data } = props ?? {};

      return postApiAskForQuotationSendAskForQuotationEmailWithJson(
        data,
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiAskForQuotationSendAskForQuotationEmailWithJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiAskForQuotationSendAskForQuotationEmailWithJson>
    >
  >;
export type PostApiAskForQuotationSendAskForQuotationEmailWithJsonMutationBody =
  VMAskForQuotation;
export type PostApiAskForQuotationSendAskForQuotationEmailWithJsonMutationError =
  ProblemDetails;

export const usePostApiAskForQuotationSendAskForQuotationEmailWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationSendAskForQuotationEmailWithJson
        >
      >,
      TError,
      { data: VMAskForQuotation },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiAskForQuotationSendAskForQuotationEmailWithJson>
  >,
  TError,
  { data: VMAskForQuotation },
  TContext
> => {
  return useMutation(
    getPostApiAskForQuotationSendAskForQuotationEmailWithJsonMutationOptions(
      options,
    ),
    queryClient,
  );
};

export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse200 =
  {
    data: void;
    status: 200;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponseSuccess =
  postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponseError =
  (
    | postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse400TextPlain
    | postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse400ApplicationJson
    | postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse400TextJson
    | postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse401TextPlain
    | postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse401ApplicationJson
    | postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse401TextJson
  ) & {
    headers: Headers;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse =
  | postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponseSuccess
  | postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponseError;

export const getPostApiAskForQuotationSendAskForQuotationEmailWithTextJsonUrl =
  () => {
    return `/api/AskForQuotation/SendAskForQuotationEmail`;
  };

export const postApiAskForQuotationSendAskForQuotationEmailWithTextJson =
  async (
    options?: RequestInit,
  ): Promise<postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse> => {
    const res = await fetch(
      getPostApiAskForQuotationSendAskForQuotationEmailWithTextJsonUrl(),
      {
        ...options,
        method: "POST",
      },
    );

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse["data"] =
      body ? JSON.parse(body) : {};
    return {
      data,
      status: res.status,
      headers: res.headers,
    } as postApiAskForQuotationSendAskForQuotationEmailWithTextJsonResponse;
  };

export const getPostApiAskForQuotationSendAskForQuotationEmailWithTextJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationSendAskForQuotationEmailWithTextJson
        >
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiAskForQuotationSendAskForQuotationEmailWithTextJson
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiAskForQuotationSendAskForQuotationEmailWithTextJson",
    ];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationSendAskForQuotationEmailWithTextJson
        >
      >,
      void
    > = () => {
      return postApiAskForQuotationSendAskForQuotationEmailWithTextJson(
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiAskForQuotationSendAskForQuotationEmailWithTextJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiAskForQuotationSendAskForQuotationEmailWithTextJson
      >
    >
  >;

export type PostApiAskForQuotationSendAskForQuotationEmailWithTextJsonMutationError =
  ProblemDetails;

export const usePostApiAskForQuotationSendAskForQuotationEmailWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationSendAskForQuotationEmailWithTextJson
        >
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postApiAskForQuotationSendAskForQuotationEmailWithTextJson
    >
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiAskForQuotationSendAskForQuotationEmailWithTextJsonMutationOptions(
      options,
    ),
    queryClient,
  );
};

export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse200 =
  {
    data: void;
    status: 200;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponseSuccess =
  postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponseError =
  (
    | postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse400TextPlain
    | postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse400ApplicationJson
    | postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse400TextJson
    | postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse401TextPlain
    | postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse401ApplicationJson
    | postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse401TextJson
  ) & {
    headers: Headers;
  };

export type postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse =
  | postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponseSuccess
  | postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponseError;

export const getPostApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonUrl =
  () => {
    return `/api/AskForQuotation/SendAskForQuotationEmail`;
  };

export const postApiAskForQuotationSendAskForQuotationEmailWithApplicationJson =
  async (
    options?: RequestInit,
  ): Promise<postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse> => {
    const res = await fetch(
      getPostApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonUrl(),
      {
        ...options,
        method: "POST",
      },
    );

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse["data"] =
      body ? JSON.parse(body) : {};
    return {
      data,
      status: res.status,
      headers: res.headers,
    } as postApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonResponse;
  };

export const getPostApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationSendAskForQuotationEmailWithApplicationJson
        >
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiAskForQuotationSendAskForQuotationEmailWithApplicationJson
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiAskForQuotationSendAskForQuotationEmailWithApplicationJson",
    ];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiAskForQuotationSendAskForQuotationEmailWithApplicationJson
        >
      >,
      void
    > = () => {
      return postApiAskForQuotationSendAskForQuotationEmailWithApplicationJson(
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiAskForQuotationSendAskForQuotationEmailWithApplicationJson
      >
    >
  >;

export type PostApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiAskForQuotationSendAskForQuotationEmailWithApplicationJson =
  <TError = ProblemDetails, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof postApiAskForQuotationSendAskForQuotationEmailWithApplicationJson
          >
        >,
        TError,
        void,
        TContext
      >;
      fetch?: RequestInit;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof postApiAskForQuotationSendAskForQuotationEmailWithApplicationJson
      >
    >,
    TError,
    void,
    TContext
  > => {
    return useMutation(
      getPostApiAskForQuotationSendAskForQuotationEmailWithApplicationJsonMutationOptions(
        options,
      ),
      queryClient,
    );
  };

export type getApiDownloadsDownloadDataSheetResponse200 = {
  data: void;
  status: 200;
};

export type getApiDownloadsDownloadDataSheetResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiDownloadsDownloadDataSheetResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiDownloadsDownloadDataSheetResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiDownloadsDownloadDataSheetResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiDownloadsDownloadDataSheetResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiDownloadsDownloadDataSheetResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiDownloadsDownloadDataSheetResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type getApiDownloadsDownloadDataSheetResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type getApiDownloadsDownloadDataSheetResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type getApiDownloadsDownloadDataSheetResponseSuccess =
  getApiDownloadsDownloadDataSheetResponse200 & {
    headers: Headers;
  };
export type getApiDownloadsDownloadDataSheetResponseError = (
  | getApiDownloadsDownloadDataSheetResponse400TextPlain
  | getApiDownloadsDownloadDataSheetResponse400ApplicationJson
  | getApiDownloadsDownloadDataSheetResponse400TextJson
  | getApiDownloadsDownloadDataSheetResponse401TextPlain
  | getApiDownloadsDownloadDataSheetResponse401ApplicationJson
  | getApiDownloadsDownloadDataSheetResponse401TextJson
  | getApiDownloadsDownloadDataSheetResponse409TextPlain
  | getApiDownloadsDownloadDataSheetResponse409ApplicationJson
  | getApiDownloadsDownloadDataSheetResponse409TextJson
) & {
  headers: Headers;
};

export type getApiDownloadsDownloadDataSheetResponse =
  | getApiDownloadsDownloadDataSheetResponseSuccess
  | getApiDownloadsDownloadDataSheetResponseError;

export const getGetApiDownloadsDownloadDataSheetUrl = (
  params?: GetApiDownloadsDownloadDataSheetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/Downloads/DownloadDataSheet?${stringifiedParams}`
    : `/api/Downloads/DownloadDataSheet`;
};

export const getApiDownloadsDownloadDataSheet = async (
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: RequestInit,
): Promise<getApiDownloadsDownloadDataSheetResponse> => {
  const res = await fetch(getGetApiDownloadsDownloadDataSheetUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiDownloadsDownloadDataSheetResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiDownloadsDownloadDataSheetResponse;
};

export const getGetApiDownloadsDownloadDataSheetQueryKey = (
  params?: GetApiDownloadsDownloadDataSheetParams,
) => {
  return [
    `/api/Downloads/DownloadDataSheet`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiDownloadsDownloadDataSheetQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = ProblemDetails,
>(
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiDownloadsDownloadDataSheetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>
  > = ({ signal }) =>
    getApiDownloadsDownloadDataSheet(params, { signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDownloadsDownloadDataSheetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>
>;
export type GetApiDownloadsDownloadDataSheetQueryError = ProblemDetails;

export function useGetApiDownloadsDownloadDataSheet<
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = ProblemDetails,
>(
  params: undefined | GetApiDownloadsDownloadDataSheetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
          TError,
          Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDownloadsDownloadDataSheet<
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = ProblemDetails,
>(
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
          TError,
          Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDownloadsDownloadDataSheet<
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = ProblemDetails,
>(
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiDownloadsDownloadDataSheet<
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = ProblemDetails,
>(
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiDownloadsDownloadDataSheetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiEasyCheckLoginStateResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCheckLoginStateResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCheckLoginStateResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCheckLoginStateResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCheckLoginStateResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCheckLoginStateResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCheckLoginStateResponseSuccess = (
  | getApiEasyCheckLoginStateResponse200TextPlain
  | getApiEasyCheckLoginStateResponse200ApplicationJson
  | getApiEasyCheckLoginStateResponse200TextJson
) & {
  headers: Headers;
};
export type getApiEasyCheckLoginStateResponseError = (
  | getApiEasyCheckLoginStateResponse401TextPlain
  | getApiEasyCheckLoginStateResponse401ApplicationJson
  | getApiEasyCheckLoginStateResponse401TextJson
) & {
  headers: Headers;
};

export type getApiEasyCheckLoginStateResponse =
  | getApiEasyCheckLoginStateResponseSuccess
  | getApiEasyCheckLoginStateResponseError;

export const getGetApiEasyCheckLoginStateUrl = () => {
  return `/api/Easy/CheckLoginState`;
};

export const getApiEasyCheckLoginState = async (
  options?: RequestInit,
): Promise<getApiEasyCheckLoginStateResponse> => {
  const res = await fetch(getGetApiEasyCheckLoginStateUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiEasyCheckLoginStateResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiEasyCheckLoginStateResponse;
};

export const getGetApiEasyCheckLoginStateQueryKey = () => {
  return [`/api/Easy/CheckLoginState`] as const;
};

export const getGetApiEasyCheckLoginStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiEasyCheckLoginStateQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiEasyCheckLoginState>>
  > = ({ signal }) => getApiEasyCheckLoginState({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiEasyCheckLoginStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiEasyCheckLoginState>>
>;
export type GetApiEasyCheckLoginStateQueryError = ProblemDetails;

export function useGetApiEasyCheckLoginState<
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyCheckLoginState>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyCheckLoginState<
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyCheckLoginState>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyCheckLoginState<
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiEasyCheckLoginState<
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiEasyCheckLoginStateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type postApiEasyRedirectToEasyWithJsonResponse200TextPlain = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyWithJsonResponse200ApplicationJson = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyWithJsonResponse200TextJson = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyWithJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyWithJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyWithJsonResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyWithJsonResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyWithJsonResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyWithJsonResponseSuccess = (
  | postApiEasyRedirectToEasyWithJsonResponse200TextPlain
  | postApiEasyRedirectToEasyWithJsonResponse200ApplicationJson
  | postApiEasyRedirectToEasyWithJsonResponse200TextJson
) & {
  headers: Headers;
};
export type postApiEasyRedirectToEasyWithJsonResponseError = (
  | postApiEasyRedirectToEasyWithJsonResponse400TextPlain
  | postApiEasyRedirectToEasyWithJsonResponse400ApplicationJson
  | postApiEasyRedirectToEasyWithJsonResponse400TextJson
  | postApiEasyRedirectToEasyWithJsonResponse401TextPlain
  | postApiEasyRedirectToEasyWithJsonResponse401ApplicationJson
  | postApiEasyRedirectToEasyWithJsonResponse401TextJson
  | postApiEasyRedirectToEasyWithJsonResponse409TextPlain
  | postApiEasyRedirectToEasyWithJsonResponse409ApplicationJson
  | postApiEasyRedirectToEasyWithJsonResponse409TextJson
) & {
  headers: Headers;
};

export type postApiEasyRedirectToEasyWithJsonResponse =
  | postApiEasyRedirectToEasyWithJsonResponseSuccess
  | postApiEasyRedirectToEasyWithJsonResponseError;

export const getPostApiEasyRedirectToEasyWithJsonUrl = () => {
  return `/api/Easy/RedirectToEasy`;
};

export const postApiEasyRedirectToEasyWithJson = async (
  vMLineItemList: VMLineItemList,
  options?: RequestInit,
): Promise<postApiEasyRedirectToEasyWithJsonResponse> => {
  const res = await fetch(getPostApiEasyRedirectToEasyWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMLineItemList),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiEasyRedirectToEasyWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasyRedirectToEasyWithJsonResponse;
};

export const getPostApiEasyRedirectToEasyWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithJson>>,
    TError,
    { data: VMLineItemList },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithJson>>,
  TError,
  { data: VMLineItemList },
  TContext
> => {
  const mutationKey = ["postApiEasyRedirectToEasyWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithJson>>,
    { data: VMLineItemList }
  > = (props) => {
    const { data } = props ?? {};

    return postApiEasyRedirectToEasyWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasyRedirectToEasyWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithJson>>
>;
export type PostApiEasyRedirectToEasyWithJsonMutationBody = VMLineItemList;
export type PostApiEasyRedirectToEasyWithJsonMutationError = ProblemDetails;

export const usePostApiEasyRedirectToEasyWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithJson>>,
      TError,
      { data: VMLineItemList },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithJson>>,
  TError,
  { data: VMLineItemList },
  TContext
> => {
  return useMutation(
    getPostApiEasyRedirectToEasyWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiEasyRedirectToEasyWithTextJsonResponse200TextPlain = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse200ApplicationJson = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse200TextJson = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyWithTextJsonResponseSuccess = (
  | postApiEasyRedirectToEasyWithTextJsonResponse200TextPlain
  | postApiEasyRedirectToEasyWithTextJsonResponse200ApplicationJson
  | postApiEasyRedirectToEasyWithTextJsonResponse200TextJson
) & {
  headers: Headers;
};
export type postApiEasyRedirectToEasyWithTextJsonResponseError = (
  | postApiEasyRedirectToEasyWithTextJsonResponse400TextPlain
  | postApiEasyRedirectToEasyWithTextJsonResponse400ApplicationJson
  | postApiEasyRedirectToEasyWithTextJsonResponse400TextJson
  | postApiEasyRedirectToEasyWithTextJsonResponse401TextPlain
  | postApiEasyRedirectToEasyWithTextJsonResponse401ApplicationJson
  | postApiEasyRedirectToEasyWithTextJsonResponse401TextJson
  | postApiEasyRedirectToEasyWithTextJsonResponse409TextPlain
  | postApiEasyRedirectToEasyWithTextJsonResponse409ApplicationJson
  | postApiEasyRedirectToEasyWithTextJsonResponse409TextJson
) & {
  headers: Headers;
};

export type postApiEasyRedirectToEasyWithTextJsonResponse =
  | postApiEasyRedirectToEasyWithTextJsonResponseSuccess
  | postApiEasyRedirectToEasyWithTextJsonResponseError;

export const getPostApiEasyRedirectToEasyWithTextJsonUrl = () => {
  return `/api/Easy/RedirectToEasy`;
};

export const postApiEasyRedirectToEasyWithTextJson = async (
  options?: RequestInit,
): Promise<postApiEasyRedirectToEasyWithTextJsonResponse> => {
  const res = await fetch(getPostApiEasyRedirectToEasyWithTextJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiEasyRedirectToEasyWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasyRedirectToEasyWithTextJsonResponse;
};

export const getPostApiEasyRedirectToEasyWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiEasyRedirectToEasyWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithTextJson>>,
    void
  > = () => {
    return postApiEasyRedirectToEasyWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasyRedirectToEasyWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithTextJson>>
>;

export type PostApiEasyRedirectToEasyWithTextJsonMutationError = ProblemDetails;

export const usePostApiEasyRedirectToEasyWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiEasyRedirectToEasyWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponse200TextPlain = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponse200ApplicationJson =
  {
    data: VMEasySynchronizationResponse;
    status: 200;
  };

export type postApiEasyRedirectToEasyWithApplicationJsonResponse200TextJson = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiEasyRedirectToEasyWithApplicationJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiEasyRedirectToEasyWithApplicationJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponse409ApplicationJson =
  {
    data: ProblemDetails;
    status: 409;
  };

export type postApiEasyRedirectToEasyWithApplicationJsonResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponseSuccess = (
  | postApiEasyRedirectToEasyWithApplicationJsonResponse200TextPlain
  | postApiEasyRedirectToEasyWithApplicationJsonResponse200ApplicationJson
  | postApiEasyRedirectToEasyWithApplicationJsonResponse200TextJson
) & {
  headers: Headers;
};
export type postApiEasyRedirectToEasyWithApplicationJsonResponseError = (
  | postApiEasyRedirectToEasyWithApplicationJsonResponse400TextPlain
  | postApiEasyRedirectToEasyWithApplicationJsonResponse400ApplicationJson
  | postApiEasyRedirectToEasyWithApplicationJsonResponse400TextJson
  | postApiEasyRedirectToEasyWithApplicationJsonResponse401TextPlain
  | postApiEasyRedirectToEasyWithApplicationJsonResponse401ApplicationJson
  | postApiEasyRedirectToEasyWithApplicationJsonResponse401TextJson
  | postApiEasyRedirectToEasyWithApplicationJsonResponse409TextPlain
  | postApiEasyRedirectToEasyWithApplicationJsonResponse409ApplicationJson
  | postApiEasyRedirectToEasyWithApplicationJsonResponse409TextJson
) & {
  headers: Headers;
};

export type postApiEasyRedirectToEasyWithApplicationJsonResponse =
  | postApiEasyRedirectToEasyWithApplicationJsonResponseSuccess
  | postApiEasyRedirectToEasyWithApplicationJsonResponseError;

export const getPostApiEasyRedirectToEasyWithApplicationJsonUrl = () => {
  return `/api/Easy/RedirectToEasy`;
};

export const postApiEasyRedirectToEasyWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiEasyRedirectToEasyWithApplicationJsonResponse> => {
  const res = await fetch(
    getPostApiEasyRedirectToEasyWithApplicationJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiEasyRedirectToEasyWithApplicationJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasyRedirectToEasyWithApplicationJsonResponse;
};

export const getPostApiEasyRedirectToEasyWithApplicationJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithApplicationJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiEasyRedirectToEasyWithApplicationJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithApplicationJson>>,
    void
  > = () => {
    return postApiEasyRedirectToEasyWithApplicationJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasyRedirectToEasyWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithApplicationJson>>
  >;

export type PostApiEasyRedirectToEasyWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiEasyRedirectToEasyWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithApplicationJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasyWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiEasyRedirectToEasyWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiEasySessionFromEasyWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiEasySessionFromEasyWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyWithJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyWithJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyWithJsonResponseSuccess =
  postApiEasySessionFromEasyWithJsonResponse200 & {
    headers: Headers;
  };
export type postApiEasySessionFromEasyWithJsonResponseError = (
  | postApiEasySessionFromEasyWithJsonResponse400TextPlain
  | postApiEasySessionFromEasyWithJsonResponse400ApplicationJson
  | postApiEasySessionFromEasyWithJsonResponse400TextJson
  | postApiEasySessionFromEasyWithJsonResponse401TextPlain
  | postApiEasySessionFromEasyWithJsonResponse401ApplicationJson
  | postApiEasySessionFromEasyWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiEasySessionFromEasyWithJsonResponse =
  | postApiEasySessionFromEasyWithJsonResponseSuccess
  | postApiEasySessionFromEasyWithJsonResponseError;

export const getPostApiEasySessionFromEasyWithJsonUrl = () => {
  return `/api/Easy/SessionFromEasy`;
};

export const postApiEasySessionFromEasyWithJson = async (
  vM3PQToEasySynchronization: VM3PQToEasySynchronization,
  options?: RequestInit,
): Promise<postApiEasySessionFromEasyWithJsonResponse> => {
  const res = await fetch(getPostApiEasySessionFromEasyWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vM3PQToEasySynchronization),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiEasySessionFromEasyWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasySessionFromEasyWithJsonResponse;
};

export const getPostApiEasySessionFromEasyWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasySessionFromEasyWithJson>>,
    TError,
    { data: VM3PQToEasySynchronization },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasySessionFromEasyWithJson>>,
  TError,
  { data: VM3PQToEasySynchronization },
  TContext
> => {
  const mutationKey = ["postApiEasySessionFromEasyWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasySessionFromEasyWithJson>>,
    { data: VM3PQToEasySynchronization }
  > = (props) => {
    const { data } = props ?? {};

    return postApiEasySessionFromEasyWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasySessionFromEasyWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiEasySessionFromEasyWithJson>>
>;
export type PostApiEasySessionFromEasyWithJsonMutationBody =
  VM3PQToEasySynchronization;
export type PostApiEasySessionFromEasyWithJsonMutationError = ProblemDetails;

export const usePostApiEasySessionFromEasyWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasySessionFromEasyWithJson>>,
      TError,
      { data: VM3PQToEasySynchronization },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasySessionFromEasyWithJson>>,
  TError,
  { data: VM3PQToEasySynchronization },
  TContext
> => {
  return useMutation(
    getPostApiEasySessionFromEasyWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiEasySessionFromEasyWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiEasySessionFromEasyWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyWithTextJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyWithTextJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyWithTextJsonResponseSuccess =
  postApiEasySessionFromEasyWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApiEasySessionFromEasyWithTextJsonResponseError = (
  | postApiEasySessionFromEasyWithTextJsonResponse400TextPlain
  | postApiEasySessionFromEasyWithTextJsonResponse400ApplicationJson
  | postApiEasySessionFromEasyWithTextJsonResponse400TextJson
  | postApiEasySessionFromEasyWithTextJsonResponse401TextPlain
  | postApiEasySessionFromEasyWithTextJsonResponse401ApplicationJson
  | postApiEasySessionFromEasyWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiEasySessionFromEasyWithTextJsonResponse =
  | postApiEasySessionFromEasyWithTextJsonResponseSuccess
  | postApiEasySessionFromEasyWithTextJsonResponseError;

export const getPostApiEasySessionFromEasyWithTextJsonUrl = () => {
  return `/api/Easy/SessionFromEasy`;
};

export const postApiEasySessionFromEasyWithTextJson = async (
  options?: RequestInit,
): Promise<postApiEasySessionFromEasyWithTextJsonResponse> => {
  const res = await fetch(getPostApiEasySessionFromEasyWithTextJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiEasySessionFromEasyWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasySessionFromEasyWithTextJsonResponse;
};

export const getPostApiEasySessionFromEasyWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasySessionFromEasyWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasySessionFromEasyWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiEasySessionFromEasyWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasySessionFromEasyWithTextJson>>,
    void
  > = () => {
    return postApiEasySessionFromEasyWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasySessionFromEasyWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiEasySessionFromEasyWithTextJson>>
>;

export type PostApiEasySessionFromEasyWithTextJsonMutationError =
  ProblemDetails;

export const usePostApiEasySessionFromEasyWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasySessionFromEasyWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasySessionFromEasyWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiEasySessionFromEasyWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiEasySessionFromEasyWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiEasySessionFromEasyWithApplicationJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiEasySessionFromEasyWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiEasySessionFromEasyWithApplicationJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyWithApplicationJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiEasySessionFromEasyWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiEasySessionFromEasyWithApplicationJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyWithApplicationJsonResponseSuccess =
  postApiEasySessionFromEasyWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApiEasySessionFromEasyWithApplicationJsonResponseError = (
  | postApiEasySessionFromEasyWithApplicationJsonResponse400TextPlain
  | postApiEasySessionFromEasyWithApplicationJsonResponse400ApplicationJson
  | postApiEasySessionFromEasyWithApplicationJsonResponse400TextJson
  | postApiEasySessionFromEasyWithApplicationJsonResponse401TextPlain
  | postApiEasySessionFromEasyWithApplicationJsonResponse401ApplicationJson
  | postApiEasySessionFromEasyWithApplicationJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiEasySessionFromEasyWithApplicationJsonResponse =
  | postApiEasySessionFromEasyWithApplicationJsonResponseSuccess
  | postApiEasySessionFromEasyWithApplicationJsonResponseError;

export const getPostApiEasySessionFromEasyWithApplicationJsonUrl = () => {
  return `/api/Easy/SessionFromEasy`;
};

export const postApiEasySessionFromEasyWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiEasySessionFromEasyWithApplicationJsonResponse> => {
  const res = await fetch(
    getPostApiEasySessionFromEasyWithApplicationJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiEasySessionFromEasyWithApplicationJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasySessionFromEasyWithApplicationJsonResponse;
};

export const getPostApiEasySessionFromEasyWithApplicationJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasySessionFromEasyWithApplicationJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasySessionFromEasyWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiEasySessionFromEasyWithApplicationJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasySessionFromEasyWithApplicationJson>>,
    void
  > = () => {
    return postApiEasySessionFromEasyWithApplicationJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasySessionFromEasyWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiEasySessionFromEasyWithApplicationJson>>
  >;

export type PostApiEasySessionFromEasyWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiEasySessionFromEasyWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasySessionFromEasyWithApplicationJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasySessionFromEasyWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiEasySessionFromEasyWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiEasySessionFromWegWebsiteWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiEasySessionFromWegWebsiteWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromWegWebsiteWithJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiEasySessionFromWegWebsiteWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromWegWebsiteWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromWegWebsiteWithJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiEasySessionFromWegWebsiteWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromWegWebsiteWithJsonResponseSuccess =
  postApiEasySessionFromWegWebsiteWithJsonResponse200 & {
    headers: Headers;
  };
export type postApiEasySessionFromWegWebsiteWithJsonResponseError = (
  | postApiEasySessionFromWegWebsiteWithJsonResponse400TextPlain
  | postApiEasySessionFromWegWebsiteWithJsonResponse400ApplicationJson
  | postApiEasySessionFromWegWebsiteWithJsonResponse400TextJson
  | postApiEasySessionFromWegWebsiteWithJsonResponse401TextPlain
  | postApiEasySessionFromWegWebsiteWithJsonResponse401ApplicationJson
  | postApiEasySessionFromWegWebsiteWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiEasySessionFromWegWebsiteWithJsonResponse =
  | postApiEasySessionFromWegWebsiteWithJsonResponseSuccess
  | postApiEasySessionFromWegWebsiteWithJsonResponseError;

export const getPostApiEasySessionFromWegWebsiteWithJsonUrl = () => {
  return `/api/Easy/SessionFromWegWebsite`;
};

export const postApiEasySessionFromWegWebsiteWithJson = async (
  vMInitiateSessionFromWebsite: VMInitiateSessionFromWebsite,
  options?: RequestInit,
): Promise<postApiEasySessionFromWegWebsiteWithJsonResponse> => {
  const res = await fetch(getPostApiEasySessionFromWegWebsiteWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMInitiateSessionFromWebsite),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiEasySessionFromWegWebsiteWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasySessionFromWegWebsiteWithJsonResponse;
};

export const getPostApiEasySessionFromWegWebsiteWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithJson>>,
    TError,
    { data: VMInitiateSessionFromWebsite },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithJson>>,
  TError,
  { data: VMInitiateSessionFromWebsite },
  TContext
> => {
  const mutationKey = ["postApiEasySessionFromWegWebsiteWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithJson>>,
    { data: VMInitiateSessionFromWebsite }
  > = (props) => {
    const { data } = props ?? {};

    return postApiEasySessionFromWegWebsiteWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasySessionFromWegWebsiteWithJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithJson>>
  >;
export type PostApiEasySessionFromWegWebsiteWithJsonMutationBody =
  VMInitiateSessionFromWebsite;
export type PostApiEasySessionFromWegWebsiteWithJsonMutationError =
  ProblemDetails;

export const usePostApiEasySessionFromWegWebsiteWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithJson>>,
      TError,
      { data: VMInitiateSessionFromWebsite },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithJson>>,
  TError,
  { data: VMInitiateSessionFromWebsite },
  TContext
> => {
  return useMutation(
    getPostApiEasySessionFromWegWebsiteWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiEasySessionFromWegWebsiteWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiEasySessionFromWegWebsiteWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromWegWebsiteWithTextJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiEasySessionFromWegWebsiteWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromWegWebsiteWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromWegWebsiteWithTextJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiEasySessionFromWegWebsiteWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromWegWebsiteWithTextJsonResponseSuccess =
  postApiEasySessionFromWegWebsiteWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApiEasySessionFromWegWebsiteWithTextJsonResponseError = (
  | postApiEasySessionFromWegWebsiteWithTextJsonResponse400TextPlain
  | postApiEasySessionFromWegWebsiteWithTextJsonResponse400ApplicationJson
  | postApiEasySessionFromWegWebsiteWithTextJsonResponse400TextJson
  | postApiEasySessionFromWegWebsiteWithTextJsonResponse401TextPlain
  | postApiEasySessionFromWegWebsiteWithTextJsonResponse401ApplicationJson
  | postApiEasySessionFromWegWebsiteWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiEasySessionFromWegWebsiteWithTextJsonResponse =
  | postApiEasySessionFromWegWebsiteWithTextJsonResponseSuccess
  | postApiEasySessionFromWegWebsiteWithTextJsonResponseError;

export const getPostApiEasySessionFromWegWebsiteWithTextJsonUrl = () => {
  return `/api/Easy/SessionFromWegWebsite`;
};

export const postApiEasySessionFromWegWebsiteWithTextJson = async (
  options?: RequestInit,
): Promise<postApiEasySessionFromWegWebsiteWithTextJsonResponse> => {
  const res = await fetch(
    getPostApiEasySessionFromWegWebsiteWithTextJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiEasySessionFromWegWebsiteWithTextJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasySessionFromWegWebsiteWithTextJsonResponse;
};

export const getPostApiEasySessionFromWegWebsiteWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiEasySessionFromWegWebsiteWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithTextJson>>,
    void
  > = () => {
    return postApiEasySessionFromWegWebsiteWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasySessionFromWegWebsiteWithTextJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithTextJson>>
  >;

export type PostApiEasySessionFromWegWebsiteWithTextJsonMutationError =
  ProblemDetails;

export const usePostApiEasySessionFromWegWebsiteWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasySessionFromWegWebsiteWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiEasySessionFromWegWebsiteWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponseSuccess =
  postApiEasySessionFromWegWebsiteWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponseError = (
  | postApiEasySessionFromWegWebsiteWithApplicationJsonResponse400TextPlain
  | postApiEasySessionFromWegWebsiteWithApplicationJsonResponse400ApplicationJson
  | postApiEasySessionFromWegWebsiteWithApplicationJsonResponse400TextJson
  | postApiEasySessionFromWegWebsiteWithApplicationJsonResponse401TextPlain
  | postApiEasySessionFromWegWebsiteWithApplicationJsonResponse401ApplicationJson
  | postApiEasySessionFromWegWebsiteWithApplicationJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiEasySessionFromWegWebsiteWithApplicationJsonResponse =
  | postApiEasySessionFromWegWebsiteWithApplicationJsonResponseSuccess
  | postApiEasySessionFromWegWebsiteWithApplicationJsonResponseError;

export const getPostApiEasySessionFromWegWebsiteWithApplicationJsonUrl = () => {
  return `/api/Easy/SessionFromWegWebsite`;
};

export const postApiEasySessionFromWegWebsiteWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiEasySessionFromWegWebsiteWithApplicationJsonResponse> => {
  const res = await fetch(
    getPostApiEasySessionFromWegWebsiteWithApplicationJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiEasySessionFromWegWebsiteWithApplicationJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasySessionFromWegWebsiteWithApplicationJsonResponse;
};

export const getPostApiEasySessionFromWegWebsiteWithApplicationJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiEasySessionFromWegWebsiteWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiEasySessionFromWegWebsiteWithApplicationJson>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiEasySessionFromWegWebsiteWithApplicationJson"];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiEasySessionFromWegWebsiteWithApplicationJson>
      >,
      void
    > = () => {
      return postApiEasySessionFromWegWebsiteWithApplicationJson(fetchOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiEasySessionFromWegWebsiteWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiEasySessionFromWegWebsiteWithApplicationJson>
    >
  >;

export type PostApiEasySessionFromWegWebsiteWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiEasySessionFromWegWebsiteWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiEasySessionFromWegWebsiteWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiEasySessionFromWegWebsiteWithApplicationJson>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiEasySessionFromWegWebsiteWithApplicationJsonMutationOptions(
      options,
    ),
    queryClient,
  );
};

export type getApiEasyAdministrationAreaResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyAdministrationAreaResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyAdministrationAreaResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyAdministrationAreaResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaResponseSuccess = (
  | getApiEasyAdministrationAreaResponse200TextPlain
  | getApiEasyAdministrationAreaResponse200ApplicationJson
  | getApiEasyAdministrationAreaResponse200TextJson
) & {
  headers: Headers;
};
export type getApiEasyAdministrationAreaResponseError = (
  | getApiEasyAdministrationAreaResponse400TextPlain
  | getApiEasyAdministrationAreaResponse400ApplicationJson
  | getApiEasyAdministrationAreaResponse400TextJson
  | getApiEasyAdministrationAreaResponse401TextPlain
  | getApiEasyAdministrationAreaResponse401ApplicationJson
  | getApiEasyAdministrationAreaResponse401TextJson
) & {
  headers: Headers;
};

export type getApiEasyAdministrationAreaResponse =
  | getApiEasyAdministrationAreaResponseSuccess
  | getApiEasyAdministrationAreaResponseError;

export const getGetApiEasyAdministrationAreaUrl = () => {
  return `/api/Easy/AdministrationArea`;
};

export const getApiEasyAdministrationArea = async (
  options?: RequestInit,
): Promise<getApiEasyAdministrationAreaResponse> => {
  const res = await fetch(getGetApiEasyAdministrationAreaUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiEasyAdministrationAreaResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiEasyAdministrationAreaResponse;
};

export const getGetApiEasyAdministrationAreaQueryKey = () => {
  return [`/api/Easy/AdministrationArea`] as const;
};

export const getGetApiEasyAdministrationAreaQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiEasyAdministrationAreaQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiEasyAdministrationArea>>
  > = ({ signal }) => getApiEasyAdministrationArea({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiEasyAdministrationAreaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiEasyAdministrationArea>>
>;
export type GetApiEasyAdministrationAreaQueryError = ProblemDetails;

export function useGetApiEasyAdministrationArea<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyAdministrationArea>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyAdministrationArea<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyAdministrationArea>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyAdministrationArea<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiEasyAdministrationArea<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiEasyAdministrationAreaQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type putApiEasyAdministrationAreaWithJsonResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type putApiEasyAdministrationAreaWithJsonResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type putApiEasyAdministrationAreaWithJsonResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type putApiEasyAdministrationAreaWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type putApiEasyAdministrationAreaWithJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiEasyAdministrationAreaWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiEasyAdministrationAreaWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type putApiEasyAdministrationAreaWithJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiEasyAdministrationAreaWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiEasyAdministrationAreaWithJsonResponseSuccess = (
  | putApiEasyAdministrationAreaWithJsonResponse200TextPlain
  | putApiEasyAdministrationAreaWithJsonResponse200ApplicationJson
  | putApiEasyAdministrationAreaWithJsonResponse200TextJson
) & {
  headers: Headers;
};
export type putApiEasyAdministrationAreaWithJsonResponseError = (
  | putApiEasyAdministrationAreaWithJsonResponse400TextPlain
  | putApiEasyAdministrationAreaWithJsonResponse400ApplicationJson
  | putApiEasyAdministrationAreaWithJsonResponse400TextJson
  | putApiEasyAdministrationAreaWithJsonResponse401TextPlain
  | putApiEasyAdministrationAreaWithJsonResponse401ApplicationJson
  | putApiEasyAdministrationAreaWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type putApiEasyAdministrationAreaWithJsonResponse =
  | putApiEasyAdministrationAreaWithJsonResponseSuccess
  | putApiEasyAdministrationAreaWithJsonResponseError;

export const getPutApiEasyAdministrationAreaWithJsonUrl = () => {
  return `/api/Easy/AdministrationArea`;
};

export const putApiEasyAdministrationAreaWithJson = async (
  returnedString: ReturnedString,
  options?: RequestInit,
): Promise<putApiEasyAdministrationAreaWithJsonResponse> => {
  const res = await fetch(getPutApiEasyAdministrationAreaWithJsonUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(returnedString),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: putApiEasyAdministrationAreaWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiEasyAdministrationAreaWithJsonResponse;
};

export const getPutApiEasyAdministrationAreaWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithJson>>,
    TError,
    { data: ReturnedString },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithJson>>,
  TError,
  { data: ReturnedString },
  TContext
> => {
  const mutationKey = ["putApiEasyAdministrationAreaWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithJson>>,
    { data: ReturnedString }
  > = (props) => {
    const { data } = props ?? {};

    return putApiEasyAdministrationAreaWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiEasyAdministrationAreaWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithJson>>
>;
export type PutApiEasyAdministrationAreaWithJsonMutationBody = ReturnedString;
export type PutApiEasyAdministrationAreaWithJsonMutationError = ProblemDetails;

export const usePutApiEasyAdministrationAreaWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithJson>>,
      TError,
      { data: ReturnedString },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithJson>>,
  TError,
  { data: ReturnedString },
  TContext
> => {
  return useMutation(
    getPutApiEasyAdministrationAreaWithJsonMutationOptions(options),
    queryClient,
  );
};

export type putApiEasyAdministrationAreaWithTextJsonResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type putApiEasyAdministrationAreaWithTextJsonResponse200ApplicationJson =
  {
    data: ReturnedString;
    status: 200;
  };

export type putApiEasyAdministrationAreaWithTextJsonResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type putApiEasyAdministrationAreaWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type putApiEasyAdministrationAreaWithTextJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type putApiEasyAdministrationAreaWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiEasyAdministrationAreaWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type putApiEasyAdministrationAreaWithTextJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type putApiEasyAdministrationAreaWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiEasyAdministrationAreaWithTextJsonResponseSuccess = (
  | putApiEasyAdministrationAreaWithTextJsonResponse200TextPlain
  | putApiEasyAdministrationAreaWithTextJsonResponse200ApplicationJson
  | putApiEasyAdministrationAreaWithTextJsonResponse200TextJson
) & {
  headers: Headers;
};
export type putApiEasyAdministrationAreaWithTextJsonResponseError = (
  | putApiEasyAdministrationAreaWithTextJsonResponse400TextPlain
  | putApiEasyAdministrationAreaWithTextJsonResponse400ApplicationJson
  | putApiEasyAdministrationAreaWithTextJsonResponse400TextJson
  | putApiEasyAdministrationAreaWithTextJsonResponse401TextPlain
  | putApiEasyAdministrationAreaWithTextJsonResponse401ApplicationJson
  | putApiEasyAdministrationAreaWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type putApiEasyAdministrationAreaWithTextJsonResponse =
  | putApiEasyAdministrationAreaWithTextJsonResponseSuccess
  | putApiEasyAdministrationAreaWithTextJsonResponseError;

export const getPutApiEasyAdministrationAreaWithTextJsonUrl = () => {
  return `/api/Easy/AdministrationArea`;
};

export const putApiEasyAdministrationAreaWithTextJson = async (
  options?: RequestInit,
): Promise<putApiEasyAdministrationAreaWithTextJsonResponse> => {
  const res = await fetch(getPutApiEasyAdministrationAreaWithTextJsonUrl(), {
    ...options,
    method: "PUT",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: putApiEasyAdministrationAreaWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiEasyAdministrationAreaWithTextJsonResponse;
};

export const getPutApiEasyAdministrationAreaWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["putApiEasyAdministrationAreaWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithTextJson>>,
    void
  > = () => {
    return putApiEasyAdministrationAreaWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiEasyAdministrationAreaWithTextJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithTextJson>>
  >;

export type PutApiEasyAdministrationAreaWithTextJsonMutationError =
  ProblemDetails;

export const usePutApiEasyAdministrationAreaWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPutApiEasyAdministrationAreaWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type putApiEasyAdministrationAreaWithApplicationJsonResponse200TextPlain =
  {
    data: ReturnedString;
    status: 200;
  };

export type putApiEasyAdministrationAreaWithApplicationJsonResponse200ApplicationJson =
  {
    data: ReturnedString;
    status: 200;
  };

export type putApiEasyAdministrationAreaWithApplicationJsonResponse200TextJson =
  {
    data: ReturnedString;
    status: 200;
  };

export type putApiEasyAdministrationAreaWithApplicationJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type putApiEasyAdministrationAreaWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type putApiEasyAdministrationAreaWithApplicationJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type putApiEasyAdministrationAreaWithApplicationJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type putApiEasyAdministrationAreaWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type putApiEasyAdministrationAreaWithApplicationJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type putApiEasyAdministrationAreaWithApplicationJsonResponseSuccess = (
  | putApiEasyAdministrationAreaWithApplicationJsonResponse200TextPlain
  | putApiEasyAdministrationAreaWithApplicationJsonResponse200ApplicationJson
  | putApiEasyAdministrationAreaWithApplicationJsonResponse200TextJson
) & {
  headers: Headers;
};
export type putApiEasyAdministrationAreaWithApplicationJsonResponseError = (
  | putApiEasyAdministrationAreaWithApplicationJsonResponse400TextPlain
  | putApiEasyAdministrationAreaWithApplicationJsonResponse400ApplicationJson
  | putApiEasyAdministrationAreaWithApplicationJsonResponse400TextJson
  | putApiEasyAdministrationAreaWithApplicationJsonResponse401TextPlain
  | putApiEasyAdministrationAreaWithApplicationJsonResponse401ApplicationJson
  | putApiEasyAdministrationAreaWithApplicationJsonResponse401TextJson
) & {
  headers: Headers;
};

export type putApiEasyAdministrationAreaWithApplicationJsonResponse =
  | putApiEasyAdministrationAreaWithApplicationJsonResponseSuccess
  | putApiEasyAdministrationAreaWithApplicationJsonResponseError;

export const getPutApiEasyAdministrationAreaWithApplicationJsonUrl = () => {
  return `/api/Easy/AdministrationArea`;
};

export const putApiEasyAdministrationAreaWithApplicationJson = async (
  options?: RequestInit,
): Promise<putApiEasyAdministrationAreaWithApplicationJsonResponse> => {
  const res = await fetch(
    getPutApiEasyAdministrationAreaWithApplicationJsonUrl(),
    {
      ...options,
      method: "PUT",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: putApiEasyAdministrationAreaWithApplicationJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiEasyAdministrationAreaWithApplicationJsonResponse;
};

export const getPutApiEasyAdministrationAreaWithApplicationJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putApiEasyAdministrationAreaWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithApplicationJson>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["putApiEasyAdministrationAreaWithApplicationJson"];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof putApiEasyAdministrationAreaWithApplicationJson>
      >,
      void
    > = () => {
      return putApiEasyAdministrationAreaWithApplicationJson(fetchOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutApiEasyAdministrationAreaWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithApplicationJson>>
  >;

export type PutApiEasyAdministrationAreaWithApplicationJsonMutationError =
  ProblemDetails;

export const usePutApiEasyAdministrationAreaWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putApiEasyAdministrationAreaWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiEasyAdministrationAreaWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPutApiEasyAdministrationAreaWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type getApiEasyAdministrationAreaCountryListResponse200TextPlain = {
  data: VMWegStoreFinder;
  status: 200;
};

export type getApiEasyAdministrationAreaCountryListResponse200ApplicationJson =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type getApiEasyAdministrationAreaCountryListResponse200TextJson = {
  data: VMWegStoreFinder;
  status: 200;
};

export type getApiEasyAdministrationAreaCountryListResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaCountryListResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type getApiEasyAdministrationAreaCountryListResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaCountryListResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaCountryListResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type getApiEasyAdministrationAreaCountryListResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaCountryListResponseSuccess = (
  | getApiEasyAdministrationAreaCountryListResponse200TextPlain
  | getApiEasyAdministrationAreaCountryListResponse200ApplicationJson
  | getApiEasyAdministrationAreaCountryListResponse200TextJson
) & {
  headers: Headers;
};
export type getApiEasyAdministrationAreaCountryListResponseError = (
  | getApiEasyAdministrationAreaCountryListResponse400TextPlain
  | getApiEasyAdministrationAreaCountryListResponse400ApplicationJson
  | getApiEasyAdministrationAreaCountryListResponse400TextJson
  | getApiEasyAdministrationAreaCountryListResponse401TextPlain
  | getApiEasyAdministrationAreaCountryListResponse401ApplicationJson
  | getApiEasyAdministrationAreaCountryListResponse401TextJson
) & {
  headers: Headers;
};

export type getApiEasyAdministrationAreaCountryListResponse =
  | getApiEasyAdministrationAreaCountryListResponseSuccess
  | getApiEasyAdministrationAreaCountryListResponseError;

export const getGetApiEasyAdministrationAreaCountryListUrl = () => {
  return `/api/Easy/AdministrationAreaCountryList`;
};

export const getApiEasyAdministrationAreaCountryList = async (
  options?: RequestInit,
): Promise<getApiEasyAdministrationAreaCountryListResponse> => {
  const res = await fetch(getGetApiEasyAdministrationAreaCountryListUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiEasyAdministrationAreaCountryListResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiEasyAdministrationAreaCountryListResponse;
};

export const getGetApiEasyAdministrationAreaCountryListQueryKey = () => {
  return [`/api/Easy/AdministrationAreaCountryList`] as const;
};

export const getGetApiEasyAdministrationAreaCountryListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiEasyAdministrationAreaCountryListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>
  > = ({ signal }) =>
    getApiEasyAdministrationAreaCountryList({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiEasyAdministrationAreaCountryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>
>;
export type GetApiEasyAdministrationAreaCountryListQueryError = ProblemDetails;

export function useGetApiEasyAdministrationAreaCountryList<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyAdministrationAreaCountryList<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyAdministrationAreaCountryList<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiEasyAdministrationAreaCountryList<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiEasyAdministrationAreaCountryListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiEasyCountryResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCountryResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCountryResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCountryResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyCountryResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyCountryResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyCountryResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCountryResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCountryResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCountryResponseSuccess = (
  | getApiEasyCountryResponse200TextPlain
  | getApiEasyCountryResponse200ApplicationJson
  | getApiEasyCountryResponse200TextJson
) & {
  headers: Headers;
};
export type getApiEasyCountryResponseError = (
  | getApiEasyCountryResponse400TextPlain
  | getApiEasyCountryResponse400ApplicationJson
  | getApiEasyCountryResponse400TextJson
  | getApiEasyCountryResponse401TextPlain
  | getApiEasyCountryResponse401ApplicationJson
  | getApiEasyCountryResponse401TextJson
) & {
  headers: Headers;
};

export type getApiEasyCountryResponse =
  getApiEasyCountryResponseSuccess | getApiEasyCountryResponseError;

export const getGetApiEasyCountryUrl = () => {
  return `/api/Easy/Country`;
};

export const getApiEasyCountry = async (
  options?: RequestInit,
): Promise<getApiEasyCountryResponse> => {
  const res = await fetch(getGetApiEasyCountryUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiEasyCountryResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiEasyCountryResponse;
};

export const getGetApiEasyCountryQueryKey = () => {
  return [`/api/Easy/Country`] as const;
};

export const getGetApiEasyCountryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiEasyCountry>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiEasyCountryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiEasyCountry>>
  > = ({ signal }) => getApiEasyCountry({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiEasyCountry>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiEasyCountryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiEasyCountry>>
>;
export type GetApiEasyCountryQueryError = ProblemDetails;

export function useGetApiEasyCountry<
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCountry>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyCountry>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyCountry>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyCountry<
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCountry>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyCountry>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyCountry>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyCountry<
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCountry>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiEasyCountry<
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCountry>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiEasyCountryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type postApiHealthKeepaliveWithJsonResponse200TextPlain = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveWithJsonResponse200ApplicationJson = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveWithJsonResponse200TextJson = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveWithJsonResponseSuccess = (
  | postApiHealthKeepaliveWithJsonResponse200TextPlain
  | postApiHealthKeepaliveWithJsonResponse200ApplicationJson
  | postApiHealthKeepaliveWithJsonResponse200TextJson
) & {
  headers: Headers;
};
export type postApiHealthKeepaliveWithJsonResponse =
  postApiHealthKeepaliveWithJsonResponseSuccess;

export const getPostApiHealthKeepaliveWithJsonUrl = () => {
  return `/api/Health/keepalive`;
};

export const postApiHealthKeepaliveWithJson = async (
  vMIsLoggedIn: VMIsLoggedIn,
  options?: RequestInit,
): Promise<postApiHealthKeepaliveWithJsonResponse> => {
  const res = await fetch(getPostApiHealthKeepaliveWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMIsLoggedIn),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiHealthKeepaliveWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiHealthKeepaliveWithJsonResponse;
};

export const getPostApiHealthKeepaliveWithJsonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiHealthKeepaliveWithJson>>,
    TError,
    { data: VMIsLoggedIn },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiHealthKeepaliveWithJson>>,
  TError,
  { data: VMIsLoggedIn },
  TContext
> => {
  const mutationKey = ["postApiHealthKeepaliveWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiHealthKeepaliveWithJson>>,
    { data: VMIsLoggedIn }
  > = (props) => {
    const { data } = props ?? {};

    return postApiHealthKeepaliveWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiHealthKeepaliveWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiHealthKeepaliveWithJson>>
>;
export type PostApiHealthKeepaliveWithJsonMutationBody = VMIsLoggedIn;
export type PostApiHealthKeepaliveWithJsonMutationError = unknown;

export const usePostApiHealthKeepaliveWithJson = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiHealthKeepaliveWithJson>>,
      TError,
      { data: VMIsLoggedIn },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiHealthKeepaliveWithJson>>,
  TError,
  { data: VMIsLoggedIn },
  TContext
> => {
  return useMutation(
    getPostApiHealthKeepaliveWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiHealthKeepaliveWithTextJsonResponse200TextPlain = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveWithTextJsonResponse200ApplicationJson = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveWithTextJsonResponse200TextJson = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveWithTextJsonResponseSuccess = (
  | postApiHealthKeepaliveWithTextJsonResponse200TextPlain
  | postApiHealthKeepaliveWithTextJsonResponse200ApplicationJson
  | postApiHealthKeepaliveWithTextJsonResponse200TextJson
) & {
  headers: Headers;
};
export type postApiHealthKeepaliveWithTextJsonResponse =
  postApiHealthKeepaliveWithTextJsonResponseSuccess;

export const getPostApiHealthKeepaliveWithTextJsonUrl = () => {
  return `/api/Health/keepalive`;
};

export const postApiHealthKeepaliveWithTextJson = async (
  options?: RequestInit,
): Promise<postApiHealthKeepaliveWithTextJsonResponse> => {
  const res = await fetch(getPostApiHealthKeepaliveWithTextJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiHealthKeepaliveWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiHealthKeepaliveWithTextJsonResponse;
};

export const getPostApiHealthKeepaliveWithTextJsonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiHealthKeepaliveWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiHealthKeepaliveWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiHealthKeepaliveWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiHealthKeepaliveWithTextJson>>,
    void
  > = () => {
    return postApiHealthKeepaliveWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiHealthKeepaliveWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiHealthKeepaliveWithTextJson>>
>;

export type PostApiHealthKeepaliveWithTextJsonMutationError = unknown;

export const usePostApiHealthKeepaliveWithTextJson = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiHealthKeepaliveWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiHealthKeepaliveWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiHealthKeepaliveWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiHealthKeepaliveWithApplicationJsonResponse200TextPlain = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveWithApplicationJsonResponse200ApplicationJson =
  {
    data: SessionExpired;
    status: 200;
  };

export type postApiHealthKeepaliveWithApplicationJsonResponse200TextJson = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveWithApplicationJsonResponseSuccess = (
  | postApiHealthKeepaliveWithApplicationJsonResponse200TextPlain
  | postApiHealthKeepaliveWithApplicationJsonResponse200ApplicationJson
  | postApiHealthKeepaliveWithApplicationJsonResponse200TextJson
) & {
  headers: Headers;
};
export type postApiHealthKeepaliveWithApplicationJsonResponse =
  postApiHealthKeepaliveWithApplicationJsonResponseSuccess;

export const getPostApiHealthKeepaliveWithApplicationJsonUrl = () => {
  return `/api/Health/keepalive`;
};

export const postApiHealthKeepaliveWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiHealthKeepaliveWithApplicationJsonResponse> => {
  const res = await fetch(getPostApiHealthKeepaliveWithApplicationJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiHealthKeepaliveWithApplicationJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiHealthKeepaliveWithApplicationJsonResponse;
};

export const getPostApiHealthKeepaliveWithApplicationJsonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiHealthKeepaliveWithApplicationJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiHealthKeepaliveWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiHealthKeepaliveWithApplicationJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiHealthKeepaliveWithApplicationJson>>,
    void
  > = () => {
    return postApiHealthKeepaliveWithApplicationJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiHealthKeepaliveWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiHealthKeepaliveWithApplicationJson>>
  >;

export type PostApiHealthKeepaliveWithApplicationJsonMutationError = unknown;

export const usePostApiHealthKeepaliveWithApplicationJson = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiHealthKeepaliveWithApplicationJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiHealthKeepaliveWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiHealthKeepaliveWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiImportImportLineitemWithJsonResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type postApiImportImportLineitemWithJsonResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type postApiImportImportLineitemWithJsonResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type postApiImportImportLineitemWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiImportImportLineitemWithJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiImportImportLineitemWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiImportImportLineitemWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiImportImportLineitemWithJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiImportImportLineitemWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiImportImportLineitemWithJsonResponseSuccess = (
  | postApiImportImportLineitemWithJsonResponse200TextPlain
  | postApiImportImportLineitemWithJsonResponse200ApplicationJson
  | postApiImportImportLineitemWithJsonResponse200TextJson
) & {
  headers: Headers;
};
export type postApiImportImportLineitemWithJsonResponseError = (
  | postApiImportImportLineitemWithJsonResponse400TextPlain
  | postApiImportImportLineitemWithJsonResponse400ApplicationJson
  | postApiImportImportLineitemWithJsonResponse400TextJson
  | postApiImportImportLineitemWithJsonResponse401TextPlain
  | postApiImportImportLineitemWithJsonResponse401ApplicationJson
  | postApiImportImportLineitemWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiImportImportLineitemWithJsonResponse =
  | postApiImportImportLineitemWithJsonResponseSuccess
  | postApiImportImportLineitemWithJsonResponseError;

export const getPostApiImportImportLineitemWithJsonUrl = () => {
  return `/api/Import/ImportLineitem`;
};

export const postApiImportImportLineitemWithJson = async (
  vMImportLineItem: VMImportLineItem,
  options?: RequestInit,
): Promise<postApiImportImportLineitemWithJsonResponse> => {
  const res = await fetch(getPostApiImportImportLineitemWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMImportLineItem),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiImportImportLineitemWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiImportImportLineitemWithJsonResponse;
};

export const getPostApiImportImportLineitemWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiImportImportLineitemWithJson>>,
    TError,
    { data: VMImportLineItem },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiImportImportLineitemWithJson>>,
  TError,
  { data: VMImportLineItem },
  TContext
> => {
  const mutationKey = ["postApiImportImportLineitemWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiImportImportLineitemWithJson>>,
    { data: VMImportLineItem }
  > = (props) => {
    const { data } = props ?? {};

    return postApiImportImportLineitemWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiImportImportLineitemWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiImportImportLineitemWithJson>>
>;
export type PostApiImportImportLineitemWithJsonMutationBody = VMImportLineItem;
export type PostApiImportImportLineitemWithJsonMutationError = ProblemDetails;

export const usePostApiImportImportLineitemWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiImportImportLineitemWithJson>>,
      TError,
      { data: VMImportLineItem },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiImportImportLineitemWithJson>>,
  TError,
  { data: VMImportLineItem },
  TContext
> => {
  return useMutation(
    getPostApiImportImportLineitemWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiImportImportLineitemWithTextJsonResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type postApiImportImportLineitemWithTextJsonResponse200ApplicationJson =
  {
    data: ReturnedString;
    status: 200;
  };

export type postApiImportImportLineitemWithTextJsonResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type postApiImportImportLineitemWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiImportImportLineitemWithTextJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiImportImportLineitemWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiImportImportLineitemWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiImportImportLineitemWithTextJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiImportImportLineitemWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiImportImportLineitemWithTextJsonResponseSuccess = (
  | postApiImportImportLineitemWithTextJsonResponse200TextPlain
  | postApiImportImportLineitemWithTextJsonResponse200ApplicationJson
  | postApiImportImportLineitemWithTextJsonResponse200TextJson
) & {
  headers: Headers;
};
export type postApiImportImportLineitemWithTextJsonResponseError = (
  | postApiImportImportLineitemWithTextJsonResponse400TextPlain
  | postApiImportImportLineitemWithTextJsonResponse400ApplicationJson
  | postApiImportImportLineitemWithTextJsonResponse400TextJson
  | postApiImportImportLineitemWithTextJsonResponse401TextPlain
  | postApiImportImportLineitemWithTextJsonResponse401ApplicationJson
  | postApiImportImportLineitemWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiImportImportLineitemWithTextJsonResponse =
  | postApiImportImportLineitemWithTextJsonResponseSuccess
  | postApiImportImportLineitemWithTextJsonResponseError;

export const getPostApiImportImportLineitemWithTextJsonUrl = () => {
  return `/api/Import/ImportLineitem`;
};

export const postApiImportImportLineitemWithTextJson = async (
  options?: RequestInit,
): Promise<postApiImportImportLineitemWithTextJsonResponse> => {
  const res = await fetch(getPostApiImportImportLineitemWithTextJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiImportImportLineitemWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiImportImportLineitemWithTextJsonResponse;
};

export const getPostApiImportImportLineitemWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiImportImportLineitemWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiImportImportLineitemWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiImportImportLineitemWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiImportImportLineitemWithTextJson>>,
    void
  > = () => {
    return postApiImportImportLineitemWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiImportImportLineitemWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiImportImportLineitemWithTextJson>>
>;

export type PostApiImportImportLineitemWithTextJsonMutationError =
  ProblemDetails;

export const usePostApiImportImportLineitemWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiImportImportLineitemWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiImportImportLineitemWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiImportImportLineitemWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiImportImportLineitemWithApplicationJsonResponse200TextPlain =
  {
    data: ReturnedString;
    status: 200;
  };

export type postApiImportImportLineitemWithApplicationJsonResponse200ApplicationJson =
  {
    data: ReturnedString;
    status: 200;
  };

export type postApiImportImportLineitemWithApplicationJsonResponse200TextJson =
  {
    data: ReturnedString;
    status: 200;
  };

export type postApiImportImportLineitemWithApplicationJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiImportImportLineitemWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiImportImportLineitemWithApplicationJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiImportImportLineitemWithApplicationJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiImportImportLineitemWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiImportImportLineitemWithApplicationJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiImportImportLineitemWithApplicationJsonResponseSuccess = (
  | postApiImportImportLineitemWithApplicationJsonResponse200TextPlain
  | postApiImportImportLineitemWithApplicationJsonResponse200ApplicationJson
  | postApiImportImportLineitemWithApplicationJsonResponse200TextJson
) & {
  headers: Headers;
};
export type postApiImportImportLineitemWithApplicationJsonResponseError = (
  | postApiImportImportLineitemWithApplicationJsonResponse400TextPlain
  | postApiImportImportLineitemWithApplicationJsonResponse400ApplicationJson
  | postApiImportImportLineitemWithApplicationJsonResponse400TextJson
  | postApiImportImportLineitemWithApplicationJsonResponse401TextPlain
  | postApiImportImportLineitemWithApplicationJsonResponse401ApplicationJson
  | postApiImportImportLineitemWithApplicationJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiImportImportLineitemWithApplicationJsonResponse =
  | postApiImportImportLineitemWithApplicationJsonResponseSuccess
  | postApiImportImportLineitemWithApplicationJsonResponseError;

export const getPostApiImportImportLineitemWithApplicationJsonUrl = () => {
  return `/api/Import/ImportLineitem`;
};

export const postApiImportImportLineitemWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiImportImportLineitemWithApplicationJsonResponse> => {
  const res = await fetch(
    getPostApiImportImportLineitemWithApplicationJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiImportImportLineitemWithApplicationJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiImportImportLineitemWithApplicationJsonResponse;
};

export const getPostApiImportImportLineitemWithApplicationJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiImportImportLineitemWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiImportImportLineitemWithApplicationJson>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiImportImportLineitemWithApplicationJson"];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiImportImportLineitemWithApplicationJson>
      >,
      void
    > = () => {
      return postApiImportImportLineitemWithApplicationJson(fetchOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiImportImportLineitemWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiImportImportLineitemWithApplicationJson>>
  >;

export type PostApiImportImportLineitemWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiImportImportLineitemWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiImportImportLineitemWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiImportImportLineitemWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiImportImportLineitemWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type getApiLineItemApiLineItemPropertiesResponse200TextPlain = {
  data: VMLineItemInformation;
  status: 200;
};

export type getApiLineItemApiLineItemPropertiesResponse200ApplicationJson = {
  data: VMLineItemInformation;
  status: 200;
};

export type getApiLineItemApiLineItemPropertiesResponse200TextJson = {
  data: VMLineItemInformation;
  status: 200;
};

export type getApiLineItemApiLineItemPropertiesResponseSuccess = (
  | getApiLineItemApiLineItemPropertiesResponse200TextPlain
  | getApiLineItemApiLineItemPropertiesResponse200ApplicationJson
  | getApiLineItemApiLineItemPropertiesResponse200TextJson
) & {
  headers: Headers;
};
export type getApiLineItemApiLineItemPropertiesResponse =
  getApiLineItemApiLineItemPropertiesResponseSuccess;

export const getGetApiLineItemApiLineItemPropertiesUrl = (
  params?: GetApiLineItemApiLineItemPropertiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/LineItemApi/LineItemProperties?${stringifiedParams}`
    : `/api/LineItemApi/LineItemProperties`;
};

export const getApiLineItemApiLineItemProperties = async (
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: RequestInit,
): Promise<getApiLineItemApiLineItemPropertiesResponse> => {
  const res = await fetch(getGetApiLineItemApiLineItemPropertiesUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiLineItemApiLineItemPropertiesResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiLineItemApiLineItemPropertiesResponse;
};

export const getGetApiLineItemApiLineItemPropertiesQueryKey = (
  params?: GetApiLineItemApiLineItemPropertiesParams,
) => {
  return [
    `/api/LineItemApi/LineItemProperties`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLineItemApiLineItemPropertiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = unknown,
>(
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLineItemApiLineItemPropertiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>
  > = ({ signal }) =>
    getApiLineItemApiLineItemProperties(params, { signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLineItemApiLineItemPropertiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>
>;
export type GetApiLineItemApiLineItemPropertiesQueryError = unknown;

export function useGetApiLineItemApiLineItemProperties<
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = unknown,
>(
  params: undefined | GetApiLineItemApiLineItemPropertiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
          TError,
          Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLineItemApiLineItemProperties<
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = unknown,
>(
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
          TError,
          Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLineItemApiLineItemProperties<
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = unknown,
>(
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLineItemApiLineItemProperties<
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = unknown,
>(
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLineItemApiLineItemPropertiesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type putApiLineItemApiLineItemPropertiesWithJsonResponse200TextPlain = {
  data: VMLineItemInformation;
  status: 200;
};

export type putApiLineItemApiLineItemPropertiesWithJsonResponse200ApplicationJson =
  {
    data: VMLineItemInformation;
    status: 200;
  };

export type putApiLineItemApiLineItemPropertiesWithJsonResponse200TextJson = {
  data: VMLineItemInformation;
  status: 200;
};

export type putApiLineItemApiLineItemPropertiesWithJsonResponseSuccess = (
  | putApiLineItemApiLineItemPropertiesWithJsonResponse200TextPlain
  | putApiLineItemApiLineItemPropertiesWithJsonResponse200ApplicationJson
  | putApiLineItemApiLineItemPropertiesWithJsonResponse200TextJson
) & {
  headers: Headers;
};
export type putApiLineItemApiLineItemPropertiesWithJsonResponse =
  putApiLineItemApiLineItemPropertiesWithJsonResponseSuccess;

export const getPutApiLineItemApiLineItemPropertiesWithJsonUrl = (
  params?: PutApiLineItemApiLineItemPropertiesWithJsonParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/LineItemApi/LineItemProperties?${stringifiedParams}`
    : `/api/LineItemApi/LineItemProperties`;
};

export const putApiLineItemApiLineItemPropertiesWithJson = async (
  vMLineItemInformation: VMLineItemInformation,
  params?: PutApiLineItemApiLineItemPropertiesWithJsonParams,
  options?: RequestInit,
): Promise<putApiLineItemApiLineItemPropertiesWithJsonResponse> => {
  const res = await fetch(
    getPutApiLineItemApiLineItemPropertiesWithJsonUrl(params),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(vMLineItemInformation),
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: putApiLineItemApiLineItemPropertiesWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiLineItemApiLineItemPropertiesWithJsonResponse;
};

export const getPutApiLineItemApiLineItemPropertiesWithJsonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLineItemApiLineItemPropertiesWithJson>>,
    TError,
    {
      data: VMLineItemInformation;
      params?: PutApiLineItemApiLineItemPropertiesWithJsonParams;
    },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLineItemApiLineItemPropertiesWithJson>>,
  TError,
  {
    data: VMLineItemInformation;
    params?: PutApiLineItemApiLineItemPropertiesWithJsonParams;
  },
  TContext
> => {
  const mutationKey = ["putApiLineItemApiLineItemPropertiesWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLineItemApiLineItemPropertiesWithJson>>,
    {
      data: VMLineItemInformation;
      params?: PutApiLineItemApiLineItemPropertiesWithJsonParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return putApiLineItemApiLineItemPropertiesWithJson(
      data,
      params,
      fetchOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLineItemApiLineItemPropertiesWithJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiLineItemApiLineItemPropertiesWithJson>>
  >;
export type PutApiLineItemApiLineItemPropertiesWithJsonMutationBody =
  VMLineItemInformation;
export type PutApiLineItemApiLineItemPropertiesWithJsonMutationError = unknown;

export const usePutApiLineItemApiLineItemPropertiesWithJson = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiLineItemApiLineItemPropertiesWithJson>>,
      TError,
      {
        data: VMLineItemInformation;
        params?: PutApiLineItemApiLineItemPropertiesWithJsonParams;
      },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiLineItemApiLineItemPropertiesWithJson>>,
  TError,
  {
    data: VMLineItemInformation;
    params?: PutApiLineItemApiLineItemPropertiesWithJsonParams;
  },
  TContext
> => {
  return useMutation(
    getPutApiLineItemApiLineItemPropertiesWithJsonMutationOptions(options),
    queryClient,
  );
};

export type putApiLineItemApiLineItemPropertiesWithTextJsonResponse200TextPlain =
  {
    data: VMLineItemInformation;
    status: 200;
  };

export type putApiLineItemApiLineItemPropertiesWithTextJsonResponse200ApplicationJson =
  {
    data: VMLineItemInformation;
    status: 200;
  };

export type putApiLineItemApiLineItemPropertiesWithTextJsonResponse200TextJson =
  {
    data: VMLineItemInformation;
    status: 200;
  };

export type putApiLineItemApiLineItemPropertiesWithTextJsonResponseSuccess = (
  | putApiLineItemApiLineItemPropertiesWithTextJsonResponse200TextPlain
  | putApiLineItemApiLineItemPropertiesWithTextJsonResponse200ApplicationJson
  | putApiLineItemApiLineItemPropertiesWithTextJsonResponse200TextJson
) & {
  headers: Headers;
};
export type putApiLineItemApiLineItemPropertiesWithTextJsonResponse =
  putApiLineItemApiLineItemPropertiesWithTextJsonResponseSuccess;

export const getPutApiLineItemApiLineItemPropertiesWithTextJsonUrl = (
  params?: PutApiLineItemApiLineItemPropertiesWithTextJsonParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/LineItemApi/LineItemProperties?${stringifiedParams}`
    : `/api/LineItemApi/LineItemProperties`;
};

export const putApiLineItemApiLineItemPropertiesWithTextJson = async (
  params?: PutApiLineItemApiLineItemPropertiesWithTextJsonParams,
  options?: RequestInit,
): Promise<putApiLineItemApiLineItemPropertiesWithTextJsonResponse> => {
  const res = await fetch(
    getPutApiLineItemApiLineItemPropertiesWithTextJsonUrl(params),
    {
      ...options,
      method: "PUT",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: putApiLineItemApiLineItemPropertiesWithTextJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiLineItemApiLineItemPropertiesWithTextJsonResponse;
};

export const getPutApiLineItemApiLineItemPropertiesWithTextJsonMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putApiLineItemApiLineItemPropertiesWithTextJson>
      >,
      TError,
      { params?: PutApiLineItemApiLineItemPropertiesWithTextJsonParams },
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof putApiLineItemApiLineItemPropertiesWithTextJson>>,
    TError,
    { params?: PutApiLineItemApiLineItemPropertiesWithTextJsonParams },
    TContext
  > => {
    const mutationKey = ["putApiLineItemApiLineItemPropertiesWithTextJson"];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof putApiLineItemApiLineItemPropertiesWithTextJson>
      >,
      { params?: PutApiLineItemApiLineItemPropertiesWithTextJsonParams }
    > = (props) => {
      const { params } = props ?? {};

      return putApiLineItemApiLineItemPropertiesWithTextJson(
        params,
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutApiLineItemApiLineItemPropertiesWithTextJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiLineItemApiLineItemPropertiesWithTextJson>>
  >;

export type PutApiLineItemApiLineItemPropertiesWithTextJsonMutationError =
  unknown;

export const usePutApiLineItemApiLineItemPropertiesWithTextJson = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putApiLineItemApiLineItemPropertiesWithTextJson>
      >,
      TError,
      { params?: PutApiLineItemApiLineItemPropertiesWithTextJsonParams },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiLineItemApiLineItemPropertiesWithTextJson>>,
  TError,
  { params?: PutApiLineItemApiLineItemPropertiesWithTextJsonParams },
  TContext
> => {
  return useMutation(
    getPutApiLineItemApiLineItemPropertiesWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse200TextPlain =
  {
    data: VMLineItemInformation;
    status: 200;
  };

export type putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse200ApplicationJson =
  {
    data: VMLineItemInformation;
    status: 200;
  };

export type putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse200TextJson =
  {
    data: VMLineItemInformation;
    status: 200;
  };

export type putApiLineItemApiLineItemPropertiesWithApplicationJsonResponseSuccess =
  (
    | putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse200TextPlain
    | putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse200ApplicationJson
    | putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse200TextJson
  ) & {
    headers: Headers;
  };
export type putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse =
  putApiLineItemApiLineItemPropertiesWithApplicationJsonResponseSuccess;

export const getPutApiLineItemApiLineItemPropertiesWithApplicationJsonUrl = (
  params?: PutApiLineItemApiLineItemPropertiesWithApplicationJsonParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/LineItemApi/LineItemProperties?${stringifiedParams}`
    : `/api/LineItemApi/LineItemProperties`;
};

export const putApiLineItemApiLineItemPropertiesWithApplicationJson = async (
  params?: PutApiLineItemApiLineItemPropertiesWithApplicationJsonParams,
  options?: RequestInit,
): Promise<putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse> => {
  const res = await fetch(
    getPutApiLineItemApiLineItemPropertiesWithApplicationJsonUrl(params),
    {
      ...options,
      method: "PUT",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiLineItemApiLineItemPropertiesWithApplicationJsonResponse;
};

export const getPutApiLineItemApiLineItemPropertiesWithApplicationJsonMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof putApiLineItemApiLineItemPropertiesWithApplicationJson
        >
      >,
      TError,
      { params?: PutApiLineItemApiLineItemPropertiesWithApplicationJsonParams },
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof putApiLineItemApiLineItemPropertiesWithApplicationJson>
    >,
    TError,
    { params?: PutApiLineItemApiLineItemPropertiesWithApplicationJsonParams },
    TContext
  > => {
    const mutationKey = [
      "putApiLineItemApiLineItemPropertiesWithApplicationJson",
    ];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof putApiLineItemApiLineItemPropertiesWithApplicationJson
        >
      >,
      { params?: PutApiLineItemApiLineItemPropertiesWithApplicationJsonParams }
    > = (props) => {
      const { params } = props ?? {};

      return putApiLineItemApiLineItemPropertiesWithApplicationJson(
        params,
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutApiLineItemApiLineItemPropertiesWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof putApiLineItemApiLineItemPropertiesWithApplicationJson>
    >
  >;

export type PutApiLineItemApiLineItemPropertiesWithApplicationJsonMutationError =
  unknown;

export const usePutApiLineItemApiLineItemPropertiesWithApplicationJson = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof putApiLineItemApiLineItemPropertiesWithApplicationJson
        >
      >,
      TError,
      { params?: PutApiLineItemApiLineItemPropertiesWithApplicationJsonParams },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof putApiLineItemApiLineItemPropertiesWithApplicationJson>
  >,
  TError,
  { params?: PutApiLineItemApiLineItemPropertiesWithApplicationJsonParams },
  TContext
> => {
  return useMutation(
    getPutApiLineItemApiLineItemPropertiesWithApplicationJsonMutationOptions(
      options,
    ),
    queryClient,
  );
};

export type postApi3pqCpqV1LineitemsCloneIdResponse200 = {
  data: void;
  status: 200;
};

export type postApi3pqCpqV1LineitemsCloneIdResponseSuccess =
  postApi3pqCpqV1LineitemsCloneIdResponse200 & {
    headers: Headers;
  };
export type postApi3pqCpqV1LineitemsCloneIdResponse =
  postApi3pqCpqV1LineitemsCloneIdResponseSuccess;

export const getPostApi3pqCpqV1LineitemsCloneIdUrl = (
  id: string,
  params?: PostApi3pqCpqV1LineitemsCloneIdParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/3pq-cpq/v1/lineitems/clone/${id}?${stringifiedParams}`
    : `/api/3pq-cpq/v1/lineitems/clone/${id}`;
};

export const postApi3pqCpqV1LineitemsCloneId = async (
  id: string,
  params?: PostApi3pqCpqV1LineitemsCloneIdParams,
  options?: RequestInit,
): Promise<postApi3pqCpqV1LineitemsCloneIdResponse> => {
  const res = await fetch(getPostApi3pqCpqV1LineitemsCloneIdUrl(id, params), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApi3pqCpqV1LineitemsCloneIdResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApi3pqCpqV1LineitemsCloneIdResponse;
};

export const getPostApi3pqCpqV1LineitemsCloneIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
    TError,
    { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
  TError,
  { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams },
  TContext
> => {
  const mutationKey = ["postApi3pqCpqV1LineitemsCloneId"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
    { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return postApi3pqCpqV1LineitemsCloneId(id, params, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApi3pqCpqV1LineitemsCloneIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>
>;

export type PostApi3pqCpqV1LineitemsCloneIdMutationError = unknown;

export const usePostApi3pqCpqV1LineitemsCloneId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
      TError,
      { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
  TError,
  { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams },
  TContext
> => {
  return useMutation(
    getPostApi3pqCpqV1LineitemsCloneIdMutationOptions(options),
    queryClient,
  );
};

export type deleteApi3pqCpqV1LineitemsIdResponse200 = {
  data: void;
  status: 200;
};

export type deleteApi3pqCpqV1LineitemsIdResponseSuccess =
  deleteApi3pqCpqV1LineitemsIdResponse200 & {
    headers: Headers;
  };
export type deleteApi3pqCpqV1LineitemsIdResponse =
  deleteApi3pqCpqV1LineitemsIdResponseSuccess;

export const getDeleteApi3pqCpqV1LineitemsIdUrl = (id: string) => {
  return `/api/3pq-cpq/v1/lineitems/${id}`;
};

export const deleteApi3pqCpqV1LineitemsId = async (
  id: string,
  options?: RequestInit,
): Promise<deleteApi3pqCpqV1LineitemsIdResponse> => {
  const res = await fetch(getDeleteApi3pqCpqV1LineitemsIdUrl(id), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteApi3pqCpqV1LineitemsIdResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deleteApi3pqCpqV1LineitemsIdResponse;
};

export const getDeleteApi3pqCpqV1LineitemsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
    TError,
    { id: string },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteApi3pqCpqV1LineitemsId"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApi3pqCpqV1LineitemsId(id, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApi3pqCpqV1LineitemsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>
>;

export type DeleteApi3pqCpqV1LineitemsIdMutationError = unknown;

export const useDeleteApi3pqCpqV1LineitemsId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
      TError,
      { id: string },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getDeleteApi3pqCpqV1LineitemsIdMutationOptions(options),
    queryClient,
  );
};

export type postApiNeedHelpNeedHelpWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiNeedHelpNeedHelpWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpWithJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpWithJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpWithJsonResponseSuccess =
  postApiNeedHelpNeedHelpWithJsonResponse200 & {
    headers: Headers;
  };
export type postApiNeedHelpNeedHelpWithJsonResponseError = (
  | postApiNeedHelpNeedHelpWithJsonResponse400TextPlain
  | postApiNeedHelpNeedHelpWithJsonResponse400ApplicationJson
  | postApiNeedHelpNeedHelpWithJsonResponse400TextJson
  | postApiNeedHelpNeedHelpWithJsonResponse401TextPlain
  | postApiNeedHelpNeedHelpWithJsonResponse401ApplicationJson
  | postApiNeedHelpNeedHelpWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiNeedHelpNeedHelpWithJsonResponse =
  | postApiNeedHelpNeedHelpWithJsonResponseSuccess
  | postApiNeedHelpNeedHelpWithJsonResponseError;

export const getPostApiNeedHelpNeedHelpWithJsonUrl = () => {
  return `/api/NeedHelp/NeedHelp`;
};

export const postApiNeedHelpNeedHelpWithJson = async (
  needHelp: NeedHelp,
  options?: RequestInit,
): Promise<postApiNeedHelpNeedHelpWithJsonResponse> => {
  const res = await fetch(getPostApiNeedHelpNeedHelpWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(needHelp),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiNeedHelpNeedHelpWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiNeedHelpNeedHelpWithJsonResponse;
};

export const getPostApiNeedHelpNeedHelpWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithJson>>,
    TError,
    { data: NeedHelp },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithJson>>,
  TError,
  { data: NeedHelp },
  TContext
> => {
  const mutationKey = ["postApiNeedHelpNeedHelpWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithJson>>,
    { data: NeedHelp }
  > = (props) => {
    const { data } = props ?? {};

    return postApiNeedHelpNeedHelpWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiNeedHelpNeedHelpWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithJson>>
>;
export type PostApiNeedHelpNeedHelpWithJsonMutationBody = NeedHelp;
export type PostApiNeedHelpNeedHelpWithJsonMutationError = ProblemDetails;

export const usePostApiNeedHelpNeedHelpWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithJson>>,
      TError,
      { data: NeedHelp },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithJson>>,
  TError,
  { data: NeedHelp },
  TContext
> => {
  return useMutation(
    getPostApiNeedHelpNeedHelpWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiNeedHelpNeedHelpWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiNeedHelpNeedHelpWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpWithTextJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpWithTextJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpWithTextJsonResponseSuccess =
  postApiNeedHelpNeedHelpWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApiNeedHelpNeedHelpWithTextJsonResponseError = (
  | postApiNeedHelpNeedHelpWithTextJsonResponse400TextPlain
  | postApiNeedHelpNeedHelpWithTextJsonResponse400ApplicationJson
  | postApiNeedHelpNeedHelpWithTextJsonResponse400TextJson
  | postApiNeedHelpNeedHelpWithTextJsonResponse401TextPlain
  | postApiNeedHelpNeedHelpWithTextJsonResponse401ApplicationJson
  | postApiNeedHelpNeedHelpWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiNeedHelpNeedHelpWithTextJsonResponse =
  | postApiNeedHelpNeedHelpWithTextJsonResponseSuccess
  | postApiNeedHelpNeedHelpWithTextJsonResponseError;

export const getPostApiNeedHelpNeedHelpWithTextJsonUrl = () => {
  return `/api/NeedHelp/NeedHelp`;
};

export const postApiNeedHelpNeedHelpWithTextJson = async (
  options?: RequestInit,
): Promise<postApiNeedHelpNeedHelpWithTextJsonResponse> => {
  const res = await fetch(getPostApiNeedHelpNeedHelpWithTextJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiNeedHelpNeedHelpWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiNeedHelpNeedHelpWithTextJsonResponse;
};

export const getPostApiNeedHelpNeedHelpWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiNeedHelpNeedHelpWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithTextJson>>,
    void
  > = () => {
    return postApiNeedHelpNeedHelpWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiNeedHelpNeedHelpWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithTextJson>>
>;

export type PostApiNeedHelpNeedHelpWithTextJsonMutationError = ProblemDetails;

export const usePostApiNeedHelpNeedHelpWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiNeedHelpNeedHelpWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiNeedHelpNeedHelpWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiNeedHelpNeedHelpWithApplicationJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiNeedHelpNeedHelpWithApplicationJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpWithApplicationJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiNeedHelpNeedHelpWithApplicationJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpWithApplicationJsonResponseSuccess =
  postApiNeedHelpNeedHelpWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApiNeedHelpNeedHelpWithApplicationJsonResponseError = (
  | postApiNeedHelpNeedHelpWithApplicationJsonResponse400TextPlain
  | postApiNeedHelpNeedHelpWithApplicationJsonResponse400ApplicationJson
  | postApiNeedHelpNeedHelpWithApplicationJsonResponse400TextJson
  | postApiNeedHelpNeedHelpWithApplicationJsonResponse401TextPlain
  | postApiNeedHelpNeedHelpWithApplicationJsonResponse401ApplicationJson
  | postApiNeedHelpNeedHelpWithApplicationJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiNeedHelpNeedHelpWithApplicationJsonResponse =
  | postApiNeedHelpNeedHelpWithApplicationJsonResponseSuccess
  | postApiNeedHelpNeedHelpWithApplicationJsonResponseError;

export const getPostApiNeedHelpNeedHelpWithApplicationJsonUrl = () => {
  return `/api/NeedHelp/NeedHelp`;
};

export const postApiNeedHelpNeedHelpWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiNeedHelpNeedHelpWithApplicationJsonResponse> => {
  const res = await fetch(getPostApiNeedHelpNeedHelpWithApplicationJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiNeedHelpNeedHelpWithApplicationJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiNeedHelpNeedHelpWithApplicationJsonResponse;
};

export const getPostApiNeedHelpNeedHelpWithApplicationJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithApplicationJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiNeedHelpNeedHelpWithApplicationJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithApplicationJson>>,
    void
  > = () => {
    return postApiNeedHelpNeedHelpWithApplicationJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiNeedHelpNeedHelpWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithApplicationJson>>
  >;

export type PostApiNeedHelpNeedHelpWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiNeedHelpNeedHelpWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithApplicationJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelpWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiNeedHelpNeedHelpWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type postApi3pqCpqV1QuotesWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApi3pqCpqV1QuotesWithJsonResponseSuccess =
  postApi3pqCpqV1QuotesWithJsonResponse200 & {
    headers: Headers;
  };
export type postApi3pqCpqV1QuotesWithJsonResponse =
  postApi3pqCpqV1QuotesWithJsonResponseSuccess;

export const getPostApi3pqCpqV1QuotesWithJsonUrl = () => {
  return `/api/3pq-cpq/v1/quotes`;
};

export const postApi3pqCpqV1QuotesWithJson = async (
  vMQuotesPost: VMQuotesPost,
  options?: RequestInit,
): Promise<postApi3pqCpqV1QuotesWithJsonResponse> => {
  const res = await fetch(getPostApi3pqCpqV1QuotesWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMQuotesPost),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApi3pqCpqV1QuotesWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApi3pqCpqV1QuotesWithJsonResponse;
};

export const getPostApi3pqCpqV1QuotesWithJsonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithJson>>,
    TError,
    { data: VMQuotesPost },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithJson>>,
  TError,
  { data: VMQuotesPost },
  TContext
> => {
  const mutationKey = ["postApi3pqCpqV1QuotesWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithJson>>,
    { data: VMQuotesPost }
  > = (props) => {
    const { data } = props ?? {};

    return postApi3pqCpqV1QuotesWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApi3pqCpqV1QuotesWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithJson>>
>;
export type PostApi3pqCpqV1QuotesWithJsonMutationBody = VMQuotesPost;
export type PostApi3pqCpqV1QuotesWithJsonMutationError = unknown;

export const usePostApi3pqCpqV1QuotesWithJson = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithJson>>,
      TError,
      { data: VMQuotesPost },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithJson>>,
  TError,
  { data: VMQuotesPost },
  TContext
> => {
  return useMutation(
    getPostApi3pqCpqV1QuotesWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApi3pqCpqV1QuotesWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApi3pqCpqV1QuotesWithTextJsonResponseSuccess =
  postApi3pqCpqV1QuotesWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApi3pqCpqV1QuotesWithTextJsonResponse =
  postApi3pqCpqV1QuotesWithTextJsonResponseSuccess;

export const getPostApi3pqCpqV1QuotesWithTextJsonUrl = () => {
  return `/api/3pq-cpq/v1/quotes`;
};

export const postApi3pqCpqV1QuotesWithTextJson = async (
  options?: RequestInit,
): Promise<postApi3pqCpqV1QuotesWithTextJsonResponse> => {
  const res = await fetch(getPostApi3pqCpqV1QuotesWithTextJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApi3pqCpqV1QuotesWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApi3pqCpqV1QuotesWithTextJsonResponse;
};

export const getPostApi3pqCpqV1QuotesWithTextJsonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApi3pqCpqV1QuotesWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithTextJson>>,
    void
  > = () => {
    return postApi3pqCpqV1QuotesWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApi3pqCpqV1QuotesWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithTextJson>>
>;

export type PostApi3pqCpqV1QuotesWithTextJsonMutationError = unknown;

export const usePostApi3pqCpqV1QuotesWithTextJson = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApi3pqCpqV1QuotesWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApi3pqCpqV1QuotesWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApi3pqCpqV1QuotesWithApplicationJsonResponseSuccess =
  postApi3pqCpqV1QuotesWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApi3pqCpqV1QuotesWithApplicationJsonResponse =
  postApi3pqCpqV1QuotesWithApplicationJsonResponseSuccess;

export const getPostApi3pqCpqV1QuotesWithApplicationJsonUrl = () => {
  return `/api/3pq-cpq/v1/quotes`;
};

export const postApi3pqCpqV1QuotesWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApi3pqCpqV1QuotesWithApplicationJsonResponse> => {
  const res = await fetch(getPostApi3pqCpqV1QuotesWithApplicationJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApi3pqCpqV1QuotesWithApplicationJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApi3pqCpqV1QuotesWithApplicationJsonResponse;
};

export const getPostApi3pqCpqV1QuotesWithApplicationJsonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithApplicationJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApi3pqCpqV1QuotesWithApplicationJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithApplicationJson>>,
    void
  > = () => {
    return postApi3pqCpqV1QuotesWithApplicationJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApi3pqCpqV1QuotesWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithApplicationJson>>
  >;

export type PostApi3pqCpqV1QuotesWithApplicationJsonMutationError = unknown;

export const usePostApi3pqCpqV1QuotesWithApplicationJson = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithApplicationJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApi3pqCpqV1QuotesWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApi3pqCpqV1QuotesWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type getApi3pqCpqV1QuotesResponse200 = {
  data: void;
  status: 200;
};

export type getApi3pqCpqV1QuotesResponseSuccess =
  getApi3pqCpqV1QuotesResponse200 & {
    headers: Headers;
  };
export type getApi3pqCpqV1QuotesResponse = getApi3pqCpqV1QuotesResponseSuccess;

export const getGetApi3pqCpqV1QuotesUrl = () => {
  return `/api/3pq-cpq/v1/quotes`;
};

export const getApi3pqCpqV1Quotes = async (
  options?: RequestInit,
): Promise<getApi3pqCpqV1QuotesResponse> => {
  const res = await fetch(getGetApi3pqCpqV1QuotesUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApi3pqCpqV1QuotesResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApi3pqCpqV1QuotesResponse;
};

export const getGetApi3pqCpqV1QuotesQueryKey = () => {
  return [`/api/3pq-cpq/v1/quotes`] as const;
};

export const getGetApi3pqCpqV1QuotesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApi3pqCpqV1QuotesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>
  > = ({ signal }) => getApi3pqCpqV1Quotes({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApi3pqCpqV1QuotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>
>;
export type GetApi3pqCpqV1QuotesQueryError = unknown;

export function useGetApi3pqCpqV1Quotes<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1Quotes<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1Quotes<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApi3pqCpqV1Quotes<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApi3pqCpqV1QuotesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApi3pqCpqV1QuotesIdResponse200 = {
  data: void;
  status: 200;
};

export type getApi3pqCpqV1QuotesIdResponseSuccess =
  getApi3pqCpqV1QuotesIdResponse200 & {
    headers: Headers;
  };
export type getApi3pqCpqV1QuotesIdResponse =
  getApi3pqCpqV1QuotesIdResponseSuccess;

export const getGetApi3pqCpqV1QuotesIdUrl = (id: string) => {
  return `/api/3pq-cpq/v1/quotes/${id}`;
};

export const getApi3pqCpqV1QuotesId = async (
  id: string,
  options?: RequestInit,
): Promise<getApi3pqCpqV1QuotesIdResponse> => {
  const res = await fetch(getGetApi3pqCpqV1QuotesIdUrl(id), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApi3pqCpqV1QuotesIdResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApi3pqCpqV1QuotesIdResponse;
};

export const getGetApi3pqCpqV1QuotesIdQueryKey = (id: string) => {
  return [`/api/3pq-cpq/v1/quotes/${id}`] as const;
};

export const getGetApi3pqCpqV1QuotesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApi3pqCpqV1QuotesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>
  > = ({ signal }) => getApi3pqCpqV1QuotesId(id, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApi3pqCpqV1QuotesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>
>;
export type GetApi3pqCpqV1QuotesIdQueryError = unknown;

export function useGetApi3pqCpqV1QuotesId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1QuotesId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1QuotesId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApi3pqCpqV1QuotesId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApi3pqCpqV1QuotesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApi3pqCpqV1QuotesGetactiveResponse200 = {
  data: void;
  status: 200;
};

export type getApi3pqCpqV1QuotesGetactiveResponseSuccess =
  getApi3pqCpqV1QuotesGetactiveResponse200 & {
    headers: Headers;
  };
export type getApi3pqCpqV1QuotesGetactiveResponse =
  getApi3pqCpqV1QuotesGetactiveResponseSuccess;

export const getGetApi3pqCpqV1QuotesGetactiveUrl = () => {
  return `/api/3pq-cpq/v1/quotes/getactive`;
};

export const getApi3pqCpqV1QuotesGetactive = async (
  options?: RequestInit,
): Promise<getApi3pqCpqV1QuotesGetactiveResponse> => {
  const res = await fetch(getGetApi3pqCpqV1QuotesGetactiveUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApi3pqCpqV1QuotesGetactiveResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApi3pqCpqV1QuotesGetactiveResponse;
};

export const getGetApi3pqCpqV1QuotesGetactiveQueryKey = () => {
  return [`/api/3pq-cpq/v1/quotes/getactive`] as const;
};

export const getGetApi3pqCpqV1QuotesGetactiveQueryOptions = <
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApi3pqCpqV1QuotesGetactiveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>
  > = ({ signal }) =>
    getApi3pqCpqV1QuotesGetactive({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApi3pqCpqV1QuotesGetactiveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>
>;
export type GetApi3pqCpqV1QuotesGetactiveQueryError = unknown;

export function useGetApi3pqCpqV1QuotesGetactive<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1QuotesGetactive<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1QuotesGetactive<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApi3pqCpqV1QuotesGetactive<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApi3pqCpqV1QuotesGetactiveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiQuoteApiGetQuoteIdResponse200TextPlain = {
  data: string;
  status: 200;
};

export type getApiQuoteApiGetQuoteIdResponse200ApplicationJson = {
  data: string;
  status: 200;
};

export type getApiQuoteApiGetQuoteIdResponse200TextJson = {
  data: string;
  status: 200;
};

export type getApiQuoteApiGetQuoteIdResponseSuccess = (
  | getApiQuoteApiGetQuoteIdResponse200TextPlain
  | getApiQuoteApiGetQuoteIdResponse200ApplicationJson
  | getApiQuoteApiGetQuoteIdResponse200TextJson
) & {
  headers: Headers;
};
export type getApiQuoteApiGetQuoteIdResponse =
  getApiQuoteApiGetQuoteIdResponseSuccess;

export const getGetApiQuoteApiGetQuoteIdUrl = () => {
  return `/api/QuoteApi/GetQuoteId`;
};

export const getApiQuoteApiGetQuoteId = async (
  options?: RequestInit,
): Promise<getApiQuoteApiGetQuoteIdResponse> => {
  const res = await fetch(getGetApiQuoteApiGetQuoteIdUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiQuoteApiGetQuoteIdResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiQuoteApiGetQuoteIdResponse;
};

export const getGetApiQuoteApiGetQuoteIdQueryKey = () => {
  return [`/api/QuoteApi/GetQuoteId`] as const;
};

export const getGetApiQuoteApiGetQuoteIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiQuoteApiGetQuoteIdQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>
  > = ({ signal }) => getApiQuoteApiGetQuoteId({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQuoteApiGetQuoteIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>
>;
export type GetApiQuoteApiGetQuoteIdQueryError = unknown;

export function useGetApiQuoteApiGetQuoteId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiGetQuoteId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiGetQuoteId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQuoteApiGetQuoteId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQuoteApiGetQuoteIdQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiQuoteApiConvertSessionFromEasyIdResponse200 = {
  data: void;
  status: 200;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponseSuccess =
  getApiQuoteApiConvertSessionFromEasyIdResponse200 & {
    headers: Headers;
  };
export type getApiQuoteApiConvertSessionFromEasyIdResponseError = (
  | getApiQuoteApiConvertSessionFromEasyIdResponse400TextPlain
  | getApiQuoteApiConvertSessionFromEasyIdResponse400ApplicationJson
  | getApiQuoteApiConvertSessionFromEasyIdResponse400TextJson
  | getApiQuoteApiConvertSessionFromEasyIdResponse401TextPlain
  | getApiQuoteApiConvertSessionFromEasyIdResponse401ApplicationJson
  | getApiQuoteApiConvertSessionFromEasyIdResponse401TextJson
) & {
  headers: Headers;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse =
  | getApiQuoteApiConvertSessionFromEasyIdResponseSuccess
  | getApiQuoteApiConvertSessionFromEasyIdResponseError;

export const getGetApiQuoteApiConvertSessionFromEasyIdUrl = (id: string) => {
  return `/api/QuoteApi/ConvertSessionFromEasy/${id}`;
};

export const getApiQuoteApiConvertSessionFromEasyId = async (
  id: string,
  options?: RequestInit,
): Promise<getApiQuoteApiConvertSessionFromEasyIdResponse> => {
  const res = await fetch(getGetApiQuoteApiConvertSessionFromEasyIdUrl(id), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiQuoteApiConvertSessionFromEasyIdResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiQuoteApiConvertSessionFromEasyIdResponse;
};

export const getGetApiQuoteApiConvertSessionFromEasyIdQueryKey = (
  id: string,
) => {
  return [`/api/QuoteApi/ConvertSessionFromEasy/${id}`] as const;
};

export const getGetApiQuoteApiConvertSessionFromEasyIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiQuoteApiConvertSessionFromEasyIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>
  > = ({ signal }) =>
    getApiQuoteApiConvertSessionFromEasyId(id, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQuoteApiConvertSessionFromEasyIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>
>;
export type GetApiQuoteApiConvertSessionFromEasyIdQueryError = ProblemDetails;

export function useGetApiQuoteApiConvertSessionFromEasyId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = ProblemDetails,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiConvertSessionFromEasyId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiConvertSessionFromEasyId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQuoteApiConvertSessionFromEasyId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = ProblemDetails,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQuoteApiConvertSessionFromEasyIdQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiQuoteApiLanguageResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type getApiQuoteApiLanguageResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiQuoteApiLanguageResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiQuoteApiLanguageResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiLanguageResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiLanguageResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiLanguageResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiLanguageResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiLanguageResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiLanguageResponseSuccess = (
  | getApiQuoteApiLanguageResponse200TextPlain
  | getApiQuoteApiLanguageResponse200ApplicationJson
  | getApiQuoteApiLanguageResponse200TextJson
) & {
  headers: Headers;
};
export type getApiQuoteApiLanguageResponseError = (
  | getApiQuoteApiLanguageResponse400TextPlain
  | getApiQuoteApiLanguageResponse400ApplicationJson
  | getApiQuoteApiLanguageResponse400TextJson
  | getApiQuoteApiLanguageResponse401TextPlain
  | getApiQuoteApiLanguageResponse401ApplicationJson
  | getApiQuoteApiLanguageResponse401TextJson
) & {
  headers: Headers;
};

export type getApiQuoteApiLanguageResponse =
  getApiQuoteApiLanguageResponseSuccess | getApiQuoteApiLanguageResponseError;

export const getGetApiQuoteApiLanguageUrl = () => {
  return `/api/QuoteApi/Language`;
};

export const getApiQuoteApiLanguage = async (
  options?: RequestInit,
): Promise<getApiQuoteApiLanguageResponse> => {
  const res = await fetch(getGetApiQuoteApiLanguageUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiQuoteApiLanguageResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiQuoteApiLanguageResponse;
};

export const getGetApiQuoteApiLanguageQueryKey = () => {
  return [`/api/QuoteApi/Language`] as const;
};

export const getGetApiQuoteApiLanguageQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiQuoteApiLanguageQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQuoteApiLanguage>>
  > = ({ signal }) => getApiQuoteApiLanguage({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQuoteApiLanguageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQuoteApiLanguage>>
>;
export type GetApiQuoteApiLanguageQueryError = ProblemDetails;

export function useGetApiQuoteApiLanguage<
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiLanguage>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiLanguage<
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiLanguage>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiLanguage<
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQuoteApiLanguage<
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQuoteApiLanguageQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type putApiQuoteApiLanguageWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type putApiQuoteApiLanguageWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageWithJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageWithJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageWithJsonResponseSuccess =
  putApiQuoteApiLanguageWithJsonResponse200 & {
    headers: Headers;
  };
export type putApiQuoteApiLanguageWithJsonResponseError = (
  | putApiQuoteApiLanguageWithJsonResponse400TextPlain
  | putApiQuoteApiLanguageWithJsonResponse400ApplicationJson
  | putApiQuoteApiLanguageWithJsonResponse400TextJson
  | putApiQuoteApiLanguageWithJsonResponse401TextPlain
  | putApiQuoteApiLanguageWithJsonResponse401ApplicationJson
  | putApiQuoteApiLanguageWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type putApiQuoteApiLanguageWithJsonResponse =
  | putApiQuoteApiLanguageWithJsonResponseSuccess
  | putApiQuoteApiLanguageWithJsonResponseError;

export const getPutApiQuoteApiLanguageWithJsonUrl = () => {
  return `/api/QuoteApi/Language`;
};

export const putApiQuoteApiLanguageWithJson = async (
  languageCodeClass: LanguageCodeClass,
  options?: RequestInit,
): Promise<putApiQuoteApiLanguageWithJsonResponse> => {
  const res = await fetch(getPutApiQuoteApiLanguageWithJsonUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(languageCodeClass),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: putApiQuoteApiLanguageWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiQuoteApiLanguageWithJsonResponse;
};

export const getPutApiQuoteApiLanguageWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiQuoteApiLanguageWithJson>>,
    TError,
    { data: LanguageCodeClass },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiQuoteApiLanguageWithJson>>,
  TError,
  { data: LanguageCodeClass },
  TContext
> => {
  const mutationKey = ["putApiQuoteApiLanguageWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiQuoteApiLanguageWithJson>>,
    { data: LanguageCodeClass }
  > = (props) => {
    const { data } = props ?? {};

    return putApiQuoteApiLanguageWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiQuoteApiLanguageWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiQuoteApiLanguageWithJson>>
>;
export type PutApiQuoteApiLanguageWithJsonMutationBody = LanguageCodeClass;
export type PutApiQuoteApiLanguageWithJsonMutationError = ProblemDetails;

export const usePutApiQuoteApiLanguageWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiQuoteApiLanguageWithJson>>,
      TError,
      { data: LanguageCodeClass },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiQuoteApiLanguageWithJson>>,
  TError,
  { data: LanguageCodeClass },
  TContext
> => {
  return useMutation(
    getPutApiQuoteApiLanguageWithJsonMutationOptions(options),
    queryClient,
  );
};

export type putApiQuoteApiLanguageWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type putApiQuoteApiLanguageWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageWithTextJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageWithTextJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageWithTextJsonResponseSuccess =
  putApiQuoteApiLanguageWithTextJsonResponse200 & {
    headers: Headers;
  };
export type putApiQuoteApiLanguageWithTextJsonResponseError = (
  | putApiQuoteApiLanguageWithTextJsonResponse400TextPlain
  | putApiQuoteApiLanguageWithTextJsonResponse400ApplicationJson
  | putApiQuoteApiLanguageWithTextJsonResponse400TextJson
  | putApiQuoteApiLanguageWithTextJsonResponse401TextPlain
  | putApiQuoteApiLanguageWithTextJsonResponse401ApplicationJson
  | putApiQuoteApiLanguageWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type putApiQuoteApiLanguageWithTextJsonResponse =
  | putApiQuoteApiLanguageWithTextJsonResponseSuccess
  | putApiQuoteApiLanguageWithTextJsonResponseError;

export const getPutApiQuoteApiLanguageWithTextJsonUrl = () => {
  return `/api/QuoteApi/Language`;
};

export const putApiQuoteApiLanguageWithTextJson = async (
  options?: RequestInit,
): Promise<putApiQuoteApiLanguageWithTextJsonResponse> => {
  const res = await fetch(getPutApiQuoteApiLanguageWithTextJsonUrl(), {
    ...options,
    method: "PUT",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: putApiQuoteApiLanguageWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiQuoteApiLanguageWithTextJsonResponse;
};

export const getPutApiQuoteApiLanguageWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiQuoteApiLanguageWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiQuoteApiLanguageWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["putApiQuoteApiLanguageWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiQuoteApiLanguageWithTextJson>>,
    void
  > = () => {
    return putApiQuoteApiLanguageWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiQuoteApiLanguageWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiQuoteApiLanguageWithTextJson>>
>;

export type PutApiQuoteApiLanguageWithTextJsonMutationError = ProblemDetails;

export const usePutApiQuoteApiLanguageWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiQuoteApiLanguageWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiQuoteApiLanguageWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPutApiQuoteApiLanguageWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type putApiQuoteApiLanguageWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type putApiQuoteApiLanguageWithApplicationJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type putApiQuoteApiLanguageWithApplicationJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageWithApplicationJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type putApiQuoteApiLanguageWithApplicationJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageWithApplicationJsonResponseSuccess =
  putApiQuoteApiLanguageWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type putApiQuoteApiLanguageWithApplicationJsonResponseError = (
  | putApiQuoteApiLanguageWithApplicationJsonResponse400TextPlain
  | putApiQuoteApiLanguageWithApplicationJsonResponse400ApplicationJson
  | putApiQuoteApiLanguageWithApplicationJsonResponse400TextJson
  | putApiQuoteApiLanguageWithApplicationJsonResponse401TextPlain
  | putApiQuoteApiLanguageWithApplicationJsonResponse401ApplicationJson
  | putApiQuoteApiLanguageWithApplicationJsonResponse401TextJson
) & {
  headers: Headers;
};

export type putApiQuoteApiLanguageWithApplicationJsonResponse =
  | putApiQuoteApiLanguageWithApplicationJsonResponseSuccess
  | putApiQuoteApiLanguageWithApplicationJsonResponseError;

export const getPutApiQuoteApiLanguageWithApplicationJsonUrl = () => {
  return `/api/QuoteApi/Language`;
};

export const putApiQuoteApiLanguageWithApplicationJson = async (
  options?: RequestInit,
): Promise<putApiQuoteApiLanguageWithApplicationJsonResponse> => {
  const res = await fetch(getPutApiQuoteApiLanguageWithApplicationJsonUrl(), {
    ...options,
    method: "PUT",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: putApiQuoteApiLanguageWithApplicationJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiQuoteApiLanguageWithApplicationJsonResponse;
};

export const getPutApiQuoteApiLanguageWithApplicationJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiQuoteApiLanguageWithApplicationJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiQuoteApiLanguageWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["putApiQuoteApiLanguageWithApplicationJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiQuoteApiLanguageWithApplicationJson>>,
    void
  > = () => {
    return putApiQuoteApiLanguageWithApplicationJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiQuoteApiLanguageWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiQuoteApiLanguageWithApplicationJson>>
  >;

export type PutApiQuoteApiLanguageWithApplicationJsonMutationError =
  ProblemDetails;

export const usePutApiQuoteApiLanguageWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiQuoteApiLanguageWithApplicationJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiQuoteApiLanguageWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPutApiQuoteApiLanguageWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type getApiQuoteApiCleanProjectListResponse200 = {
  data: void;
  status: 200;
};

export type getApiQuoteApiCleanProjectListResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiCleanProjectListResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiCleanProjectListResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiCleanProjectListResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiCleanProjectListResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiCleanProjectListResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiCleanProjectListResponseSuccess =
  getApiQuoteApiCleanProjectListResponse200 & {
    headers: Headers;
  };
export type getApiQuoteApiCleanProjectListResponseError = (
  | getApiQuoteApiCleanProjectListResponse400TextPlain
  | getApiQuoteApiCleanProjectListResponse400ApplicationJson
  | getApiQuoteApiCleanProjectListResponse400TextJson
  | getApiQuoteApiCleanProjectListResponse401TextPlain
  | getApiQuoteApiCleanProjectListResponse401ApplicationJson
  | getApiQuoteApiCleanProjectListResponse401TextJson
) & {
  headers: Headers;
};

export type getApiQuoteApiCleanProjectListResponse =
  | getApiQuoteApiCleanProjectListResponseSuccess
  | getApiQuoteApiCleanProjectListResponseError;

export const getGetApiQuoteApiCleanProjectListUrl = () => {
  return `/api/QuoteApi/CleanProjectList`;
};

export const getApiQuoteApiCleanProjectList = async (
  options?: RequestInit,
): Promise<getApiQuoteApiCleanProjectListResponse> => {
  const res = await fetch(getGetApiQuoteApiCleanProjectListUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiQuoteApiCleanProjectListResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiQuoteApiCleanProjectListResponse;
};

export const getGetApiQuoteApiCleanProjectListQueryKey = () => {
  return [`/api/QuoteApi/CleanProjectList`] as const;
};

export const getGetApiQuoteApiCleanProjectListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiQuoteApiCleanProjectListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>
  > = ({ signal }) =>
    getApiQuoteApiCleanProjectList({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQuoteApiCleanProjectListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>
>;
export type GetApiQuoteApiCleanProjectListQueryError = ProblemDetails;

export function useGetApiQuoteApiCleanProjectList<
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiCleanProjectList<
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiCleanProjectList<
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQuoteApiCleanProjectList<
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQuoteApiCleanProjectListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type deleteApiQuoteApiDeleteEmptyQuotesResponse200 = {
  data: void;
  status: 200;
};

export type deleteApiQuoteApiDeleteEmptyQuotesResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type deleteApiQuoteApiDeleteEmptyQuotesResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type deleteApiQuoteApiDeleteEmptyQuotesResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type deleteApiQuoteApiDeleteEmptyQuotesResponseSuccess =
  deleteApiQuoteApiDeleteEmptyQuotesResponse200 & {
    headers: Headers;
  };
export type deleteApiQuoteApiDeleteEmptyQuotesResponseError = (
  | deleteApiQuoteApiDeleteEmptyQuotesResponse401TextPlain
  | deleteApiQuoteApiDeleteEmptyQuotesResponse401ApplicationJson
  | deleteApiQuoteApiDeleteEmptyQuotesResponse401TextJson
) & {
  headers: Headers;
};

export type deleteApiQuoteApiDeleteEmptyQuotesResponse =
  | deleteApiQuoteApiDeleteEmptyQuotesResponseSuccess
  | deleteApiQuoteApiDeleteEmptyQuotesResponseError;

export const getDeleteApiQuoteApiDeleteEmptyQuotesUrl = (
  params?: DeleteApiQuoteApiDeleteEmptyQuotesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/QuoteApi/DeleteEmptyQuotes?${stringifiedParams}`
    : `/api/QuoteApi/DeleteEmptyQuotes`;
};

export const deleteApiQuoteApiDeleteEmptyQuotes = async (
  params?: DeleteApiQuoteApiDeleteEmptyQuotesParams,
  options?: RequestInit,
): Promise<deleteApiQuoteApiDeleteEmptyQuotesResponse> => {
  const res = await fetch(getDeleteApiQuoteApiDeleteEmptyQuotesUrl(params), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteApiQuoteApiDeleteEmptyQuotesResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deleteApiQuoteApiDeleteEmptyQuotesResponse;
};

export const getDeleteApiQuoteApiDeleteEmptyQuotesMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
    TError,
    { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
  TError,
  { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams },
  TContext
> => {
  const mutationKey = ["deleteApiQuoteApiDeleteEmptyQuotes"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
    { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteApiQuoteApiDeleteEmptyQuotes(params, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiQuoteApiDeleteEmptyQuotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>
>;

export type DeleteApiQuoteApiDeleteEmptyQuotesMutationError = ProblemDetails;

export const useDeleteApiQuoteApiDeleteEmptyQuotes = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
      TError,
      { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
  TError,
  { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams },
  TContext
> => {
  return useMutation(
    getDeleteApiQuoteApiDeleteEmptyQuotesMutationOptions(options),
    queryClient,
  );
};

export type getApi3pqCpqV1StatusIdResponse200 = {
  data: void;
  status: 200;
};

export type getApi3pqCpqV1StatusIdResponseSuccess =
  getApi3pqCpqV1StatusIdResponse200 & {
    headers: Headers;
  };
export type getApi3pqCpqV1StatusIdResponse =
  getApi3pqCpqV1StatusIdResponseSuccess;

export const getGetApi3pqCpqV1StatusIdUrl = (
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/3pq-cpq/v1/status/${id}?${stringifiedParams}`
    : `/api/3pq-cpq/v1/status/${id}`;
};

export const getApi3pqCpqV1StatusId = async (
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: RequestInit,
): Promise<getApi3pqCpqV1StatusIdResponse> => {
  const res = await fetch(getGetApi3pqCpqV1StatusIdUrl(id, params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApi3pqCpqV1StatusIdResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApi3pqCpqV1StatusIdResponse;
};

export const getGetApi3pqCpqV1StatusIdQueryKey = (
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
) => {
  return [`/api/3pq-cpq/v1/status/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetApi3pqCpqV1StatusIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = unknown,
>(
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApi3pqCpqV1StatusIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>
  > = ({ signal }) =>
    getApi3pqCpqV1StatusId(id, params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApi3pqCpqV1StatusIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>
>;
export type GetApi3pqCpqV1StatusIdQueryError = unknown;

export function useGetApi3pqCpqV1StatusId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = unknown,
>(
  id: string,
  params: undefined | GetApi3pqCpqV1StatusIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1StatusId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = unknown,
>(
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1StatusId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = unknown,
>(
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApi3pqCpqV1StatusId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = unknown,
>(
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApi3pqCpqV1StatusIdQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiTestResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestResponseSuccess = getApiTestResponse200 & {
  headers: Headers;
};
export type getApiTestResponseError = (
  | getApiTestResponse400TextPlain
  | getApiTestResponse400ApplicationJson
  | getApiTestResponse400TextJson
  | getApiTestResponse401TextPlain
  | getApiTestResponse401ApplicationJson
  | getApiTestResponse401TextJson
) & {
  headers: Headers;
};

export type getApiTestResponse =
  getApiTestResponseSuccess | getApiTestResponseError;

export const getGetApiTestUrl = () => {
  return `/api/Test`;
};

export const getApiTest = async (
  options?: RequestInit,
): Promise<getApiTestResponse> => {
  const res = await fetch(getGetApiTestUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiTestResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestResponse;
};

export const getGetApiTestQueryKey = () => {
  return [`/api/Test`] as const;
};

export const getGetApiTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTest>>> = ({
    signal,
  }) => getApiTest({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTest>>
>;
export type GetApiTestQueryError = ProblemDetails;

export function useGetApiTest<
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTest>>,
          TError,
          Awaited<ReturnType<typeof getApiTest>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTest<
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTest>>,
          TError,
          Awaited<ReturnType<typeof getApiTest>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTest<
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTest<
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiTestJWTtokenResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestJWTtokenResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtokenResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtokenResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtokenResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtokenResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtokenResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtokenResponseSuccess =
  getApiTestJWTtokenResponse200 & {
    headers: Headers;
  };
export type getApiTestJWTtokenResponseError = (
  | getApiTestJWTtokenResponse400TextPlain
  | getApiTestJWTtokenResponse400ApplicationJson
  | getApiTestJWTtokenResponse400TextJson
  | getApiTestJWTtokenResponse401TextPlain
  | getApiTestJWTtokenResponse401ApplicationJson
  | getApiTestJWTtokenResponse401TextJson
) & {
  headers: Headers;
};

export type getApiTestJWTtokenResponse =
  getApiTestJWTtokenResponseSuccess | getApiTestJWTtokenResponseError;

export const getGetApiTestJWTtokenUrl = () => {
  return `/api/Test/JWTtoken`;
};

export const getApiTestJWTtoken = async (
  options?: RequestInit,
): Promise<getApiTestJWTtokenResponse> => {
  const res = await fetch(getGetApiTestJWTtokenUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiTestJWTtokenResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestJWTtokenResponse;
};

export const getGetApiTestJWTtokenQueryKey = () => {
  return [`/api/Test/JWTtoken`] as const;
};

export const getGetApiTestJWTtokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestJWTtoken>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestJWTtokenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestJWTtoken>>
  > = ({ signal }) => getApiTestJWTtoken({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestJWTtoken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestJWTtokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestJWTtoken>>
>;
export type GetApiTestJWTtokenQueryError = ProblemDetails;

export function useGetApiTestJWTtoken<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJWTtoken>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJWTtoken>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJWTtoken<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJWTtoken>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJWTtoken>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJWTtoken<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestJWTtoken<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestJWTtokenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiTestJWTtoken2Response200 = {
  data: void;
  status: 200;
};

export type getApiTestJWTtoken2Response400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtoken2Response400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtoken2Response400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtoken2Response401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtoken2Response401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtoken2Response401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtoken2ResponseSuccess =
  getApiTestJWTtoken2Response200 & {
    headers: Headers;
  };
export type getApiTestJWTtoken2ResponseError = (
  | getApiTestJWTtoken2Response400TextPlain
  | getApiTestJWTtoken2Response400ApplicationJson
  | getApiTestJWTtoken2Response400TextJson
  | getApiTestJWTtoken2Response401TextPlain
  | getApiTestJWTtoken2Response401ApplicationJson
  | getApiTestJWTtoken2Response401TextJson
) & {
  headers: Headers;
};

export type getApiTestJWTtoken2Response =
  getApiTestJWTtoken2ResponseSuccess | getApiTestJWTtoken2ResponseError;

export const getGetApiTestJWTtoken2Url = () => {
  return `/api/Test/JWTtoken2`;
};

export const getApiTestJWTtoken2 = async (
  options?: RequestInit,
): Promise<getApiTestJWTtoken2Response> => {
  const res = await fetch(getGetApiTestJWTtoken2Url(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiTestJWTtoken2Response["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestJWTtoken2Response;
};

export const getGetApiTestJWTtoken2QueryKey = () => {
  return [`/api/Test/JWTtoken2`] as const;
};

export const getGetApiTestJWTtoken2QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestJWTtoken2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestJWTtoken2>>
  > = ({ signal }) => getApiTestJWTtoken2({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestJWTtoken2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestJWTtoken2>>
>;
export type GetApiTestJWTtoken2QueryError = ProblemDetails;

export function useGetApiTestJWTtoken2<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJWTtoken2>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJWTtoken2<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJWTtoken2>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJWTtoken2<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestJWTtoken2<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestJWTtoken2QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiTestNameResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestNameResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestNameResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestNameResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestNameResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestNameResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestNameResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestNameResponseSuccess = getApiTestNameResponse200 & {
  headers: Headers;
};
export type getApiTestNameResponseError = (
  | getApiTestNameResponse400TextPlain
  | getApiTestNameResponse400ApplicationJson
  | getApiTestNameResponse400TextJson
  | getApiTestNameResponse401TextPlain
  | getApiTestNameResponse401ApplicationJson
  | getApiTestNameResponse401TextJson
) & {
  headers: Headers;
};

export type getApiTestNameResponse =
  getApiTestNameResponseSuccess | getApiTestNameResponseError;

export const getGetApiTestNameUrl = () => {
  return `/api/Test/name`;
};

export const getApiTestName = async (
  options?: RequestInit,
): Promise<getApiTestNameResponse> => {
  const res = await fetch(getGetApiTestNameUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiTestNameResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestNameResponse;
};

export const getGetApiTestNameQueryKey = () => {
  return [`/api/Test/name`] as const;
};

export const getGetApiTestNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestNameQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTestName>>> = ({
    signal,
  }) => getApiTestName({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestName>>
>;
export type GetApiTestNameQueryError = ProblemDetails;

export function useGetApiTestName<
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestName>>,
          TError,
          Awaited<ReturnType<typeof getApiTestName>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestName<
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestName>>,
          TError,
          Awaited<ReturnType<typeof getApiTestName>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestName<
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestName<
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestNameQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiTestEasyTokenResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestEasyTokenResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestEasyTokenResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestEasyTokenResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestEasyTokenResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestEasyTokenResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestEasyTokenResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestEasyTokenResponseSuccess =
  getApiTestEasyTokenResponse200 & {
    headers: Headers;
  };
export type getApiTestEasyTokenResponseError = (
  | getApiTestEasyTokenResponse400TextPlain
  | getApiTestEasyTokenResponse400ApplicationJson
  | getApiTestEasyTokenResponse400TextJson
  | getApiTestEasyTokenResponse401TextPlain
  | getApiTestEasyTokenResponse401ApplicationJson
  | getApiTestEasyTokenResponse401TextJson
) & {
  headers: Headers;
};

export type getApiTestEasyTokenResponse =
  getApiTestEasyTokenResponseSuccess | getApiTestEasyTokenResponseError;

export const getGetApiTestEasyTokenUrl = () => {
  return `/api/Test/EasyToken`;
};

export const getApiTestEasyToken = async (
  options?: RequestInit,
): Promise<getApiTestEasyTokenResponse> => {
  const res = await fetch(getGetApiTestEasyTokenUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiTestEasyTokenResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestEasyTokenResponse;
};

export const getGetApiTestEasyTokenQueryKey = () => {
  return [`/api/Test/EasyToken`] as const;
};

export const getGetApiTestEasyTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestEasyToken>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestEasyTokenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestEasyToken>>
  > = ({ signal }) => getApiTestEasyToken({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestEasyToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestEasyTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestEasyToken>>
>;
export type GetApiTestEasyTokenQueryError = ProblemDetails;

export function useGetApiTestEasyToken<
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestEasyToken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestEasyToken>>,
          TError,
          Awaited<ReturnType<typeof getApiTestEasyToken>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestEasyToken<
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestEasyToken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestEasyToken>>,
          TError,
          Awaited<ReturnType<typeof getApiTestEasyToken>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestEasyToken<
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestEasyToken>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestEasyToken<
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestEasyToken>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestEasyTokenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type postApiTestConvertToSingleUseTokenWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestConvertToSingleUseTokenWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestConvertToSingleUseTokenWithJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestConvertToSingleUseTokenWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestConvertToSingleUseTokenWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestConvertToSingleUseTokenWithJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestConvertToSingleUseTokenWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestConvertToSingleUseTokenWithJsonResponseSuccess =
  postApiTestConvertToSingleUseTokenWithJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestConvertToSingleUseTokenWithJsonResponseError = (
  | postApiTestConvertToSingleUseTokenWithJsonResponse400TextPlain
  | postApiTestConvertToSingleUseTokenWithJsonResponse400ApplicationJson
  | postApiTestConvertToSingleUseTokenWithJsonResponse400TextJson
  | postApiTestConvertToSingleUseTokenWithJsonResponse401TextPlain
  | postApiTestConvertToSingleUseTokenWithJsonResponse401ApplicationJson
  | postApiTestConvertToSingleUseTokenWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestConvertToSingleUseTokenWithJsonResponse =
  | postApiTestConvertToSingleUseTokenWithJsonResponseSuccess
  | postApiTestConvertToSingleUseTokenWithJsonResponseError;

export const getPostApiTestConvertToSingleUseTokenWithJsonUrl = () => {
  return `/api/Test/ConvertToSingleUseToken`;
};

export const postApiTestConvertToSingleUseTokenWithJson = async (
  convertTokenInput: ConvertTokenInput,
  options?: RequestInit,
): Promise<postApiTestConvertToSingleUseTokenWithJsonResponse> => {
  const res = await fetch(getPostApiTestConvertToSingleUseTokenWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(convertTokenInput),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestConvertToSingleUseTokenWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestConvertToSingleUseTokenWithJsonResponse;
};

export const getPostApiTestConvertToSingleUseTokenWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestConvertToSingleUseTokenWithJson>>,
    TError,
    { data: ConvertTokenInput },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestConvertToSingleUseTokenWithJson>>,
  TError,
  { data: ConvertTokenInput },
  TContext
> => {
  const mutationKey = ["postApiTestConvertToSingleUseTokenWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestConvertToSingleUseTokenWithJson>>,
    { data: ConvertTokenInput }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestConvertToSingleUseTokenWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestConvertToSingleUseTokenWithJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTestConvertToSingleUseTokenWithJson>>
  >;
export type PostApiTestConvertToSingleUseTokenWithJsonMutationBody =
  ConvertTokenInput;
export type PostApiTestConvertToSingleUseTokenWithJsonMutationError =
  ProblemDetails;

export const usePostApiTestConvertToSingleUseTokenWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestConvertToSingleUseTokenWithJson>>,
      TError,
      { data: ConvertTokenInput },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestConvertToSingleUseTokenWithJson>>,
  TError,
  { data: ConvertTokenInput },
  TContext
> => {
  return useMutation(
    getPostApiTestConvertToSingleUseTokenWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestConvertToSingleUseTokenWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestConvertToSingleUseTokenWithTextJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestConvertToSingleUseTokenWithTextJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestConvertToSingleUseTokenWithTextJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestConvertToSingleUseTokenWithTextJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestConvertToSingleUseTokenWithTextJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestConvertToSingleUseTokenWithTextJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestConvertToSingleUseTokenWithTextJsonResponseSuccess =
  postApiTestConvertToSingleUseTokenWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestConvertToSingleUseTokenWithTextJsonResponseError = (
  | postApiTestConvertToSingleUseTokenWithTextJsonResponse400TextPlain
  | postApiTestConvertToSingleUseTokenWithTextJsonResponse400ApplicationJson
  | postApiTestConvertToSingleUseTokenWithTextJsonResponse400TextJson
  | postApiTestConvertToSingleUseTokenWithTextJsonResponse401TextPlain
  | postApiTestConvertToSingleUseTokenWithTextJsonResponse401ApplicationJson
  | postApiTestConvertToSingleUseTokenWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestConvertToSingleUseTokenWithTextJsonResponse =
  | postApiTestConvertToSingleUseTokenWithTextJsonResponseSuccess
  | postApiTestConvertToSingleUseTokenWithTextJsonResponseError;

export const getPostApiTestConvertToSingleUseTokenWithTextJsonUrl = () => {
  return `/api/Test/ConvertToSingleUseToken`;
};

export const postApiTestConvertToSingleUseTokenWithTextJson = async (
  options?: RequestInit,
): Promise<postApiTestConvertToSingleUseTokenWithTextJsonResponse> => {
  const res = await fetch(
    getPostApiTestConvertToSingleUseTokenWithTextJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestConvertToSingleUseTokenWithTextJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestConvertToSingleUseTokenWithTextJsonResponse;
};

export const getPostApiTestConvertToSingleUseTokenWithTextJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiTestConvertToSingleUseTokenWithTextJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestConvertToSingleUseTokenWithTextJson>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiTestConvertToSingleUseTokenWithTextJson"];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiTestConvertToSingleUseTokenWithTextJson>
      >,
      void
    > = () => {
      return postApiTestConvertToSingleUseTokenWithTextJson(fetchOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiTestConvertToSingleUseTokenWithTextJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTestConvertToSingleUseTokenWithTextJson>>
  >;

export type PostApiTestConvertToSingleUseTokenWithTextJsonMutationError =
  ProblemDetails;

export const usePostApiTestConvertToSingleUseTokenWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiTestConvertToSingleUseTokenWithTextJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestConvertToSingleUseTokenWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestConvertToSingleUseTokenWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponseSuccess =
  postApiTestConvertToSingleUseTokenWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponseError =
  (
    | postApiTestConvertToSingleUseTokenWithApplicationJsonResponse400TextPlain
    | postApiTestConvertToSingleUseTokenWithApplicationJsonResponse400ApplicationJson
    | postApiTestConvertToSingleUseTokenWithApplicationJsonResponse400TextJson
    | postApiTestConvertToSingleUseTokenWithApplicationJsonResponse401TextPlain
    | postApiTestConvertToSingleUseTokenWithApplicationJsonResponse401ApplicationJson
    | postApiTestConvertToSingleUseTokenWithApplicationJsonResponse401TextJson
  ) & {
    headers: Headers;
  };

export type postApiTestConvertToSingleUseTokenWithApplicationJsonResponse =
  | postApiTestConvertToSingleUseTokenWithApplicationJsonResponseSuccess
  | postApiTestConvertToSingleUseTokenWithApplicationJsonResponseError;

export const getPostApiTestConvertToSingleUseTokenWithApplicationJsonUrl =
  () => {
    return `/api/Test/ConvertToSingleUseToken`;
  };

export const postApiTestConvertToSingleUseTokenWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiTestConvertToSingleUseTokenWithApplicationJsonResponse> => {
  const res = await fetch(
    getPostApiTestConvertToSingleUseTokenWithApplicationJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestConvertToSingleUseTokenWithApplicationJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestConvertToSingleUseTokenWithApplicationJsonResponse;
};

export const getPostApiTestConvertToSingleUseTokenWithApplicationJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiTestConvertToSingleUseTokenWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiTestConvertToSingleUseTokenWithApplicationJson>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiTestConvertToSingleUseTokenWithApplicationJson",
    ];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiTestConvertToSingleUseTokenWithApplicationJson>
      >,
      void
    > = () => {
      return postApiTestConvertToSingleUseTokenWithApplicationJson(
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiTestConvertToSingleUseTokenWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiTestConvertToSingleUseTokenWithApplicationJson>
    >
  >;

export type PostApiTestConvertToSingleUseTokenWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiTestConvertToSingleUseTokenWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiTestConvertToSingleUseTokenWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiTestConvertToSingleUseTokenWithApplicationJson>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestConvertToSingleUseTokenWithApplicationJsonMutationOptions(
      options,
    ),
    queryClient,
  );
};

export type getApiTestJumpToEasyResponse200TextPlain = {
  data: VMEasyRedirect;
  status: 200;
};

export type getApiTestJumpToEasyResponse200ApplicationJson = {
  data: VMEasyRedirect;
  status: 200;
};

export type getApiTestJumpToEasyResponse200TextJson = {
  data: VMEasyRedirect;
  status: 200;
};

export type getApiTestJumpToEasyResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJumpToEasyResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJumpToEasyResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJumpToEasyResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJumpToEasyResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJumpToEasyResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJumpToEasyResponseSuccess = (
  | getApiTestJumpToEasyResponse200TextPlain
  | getApiTestJumpToEasyResponse200ApplicationJson
  | getApiTestJumpToEasyResponse200TextJson
) & {
  headers: Headers;
};
export type getApiTestJumpToEasyResponseError = (
  | getApiTestJumpToEasyResponse400TextPlain
  | getApiTestJumpToEasyResponse400ApplicationJson
  | getApiTestJumpToEasyResponse400TextJson
  | getApiTestJumpToEasyResponse401TextPlain
  | getApiTestJumpToEasyResponse401ApplicationJson
  | getApiTestJumpToEasyResponse401TextJson
) & {
  headers: Headers;
};

export type getApiTestJumpToEasyResponse =
  getApiTestJumpToEasyResponseSuccess | getApiTestJumpToEasyResponseError;

export const getGetApiTestJumpToEasyUrl = () => {
  return `/api/Test/JumpToEasy`;
};

export const getApiTestJumpToEasy = async (
  options?: RequestInit,
): Promise<getApiTestJumpToEasyResponse> => {
  const res = await fetch(getGetApiTestJumpToEasyUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiTestJumpToEasyResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestJumpToEasyResponse;
};

export const getGetApiTestJumpToEasyQueryKey = () => {
  return [`/api/Test/JumpToEasy`] as const;
};

export const getGetApiTestJumpToEasyQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestJumpToEasyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestJumpToEasy>>
  > = ({ signal }) => getApiTestJumpToEasy({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestJumpToEasyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestJumpToEasy>>
>;
export type GetApiTestJumpToEasyQueryError = ProblemDetails;

export function useGetApiTestJumpToEasy<
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJumpToEasy>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJumpToEasy<
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJumpToEasy>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJumpToEasy<
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestJumpToEasy<
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestJumpToEasyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type postApiTestWegTestCallWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestWegTestCallWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallWithJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallWithJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallWithJsonResponseSuccess =
  postApiTestWegTestCallWithJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestWegTestCallWithJsonResponseError = (
  | postApiTestWegTestCallWithJsonResponse400TextPlain
  | postApiTestWegTestCallWithJsonResponse400ApplicationJson
  | postApiTestWegTestCallWithJsonResponse400TextJson
  | postApiTestWegTestCallWithJsonResponse401TextPlain
  | postApiTestWegTestCallWithJsonResponse401ApplicationJson
  | postApiTestWegTestCallWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestWegTestCallWithJsonResponse =
  | postApiTestWegTestCallWithJsonResponseSuccess
  | postApiTestWegTestCallWithJsonResponseError;

export const getPostApiTestWegTestCallWithJsonUrl = () => {
  return `/api/Test/WegTestCall`;
};

export const postApiTestWegTestCallWithJson = async (
  wegTestCallInput: WegTestCallInput,
  options?: RequestInit,
): Promise<postApiTestWegTestCallWithJsonResponse> => {
  const res = await fetch(getPostApiTestWegTestCallWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(wegTestCallInput),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestWegTestCallWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestWegTestCallWithJsonResponse;
};

export const getPostApiTestWegTestCallWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestWegTestCallWithJson>>,
    TError,
    { data: WegTestCallInput },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestWegTestCallWithJson>>,
  TError,
  { data: WegTestCallInput },
  TContext
> => {
  const mutationKey = ["postApiTestWegTestCallWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestWegTestCallWithJson>>,
    { data: WegTestCallInput }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestWegTestCallWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestWegTestCallWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestWegTestCallWithJson>>
>;
export type PostApiTestWegTestCallWithJsonMutationBody = WegTestCallInput;
export type PostApiTestWegTestCallWithJsonMutationError = ProblemDetails;

export const usePostApiTestWegTestCallWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestWegTestCallWithJson>>,
      TError,
      { data: WegTestCallInput },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestWegTestCallWithJson>>,
  TError,
  { data: WegTestCallInput },
  TContext
> => {
  return useMutation(
    getPostApiTestWegTestCallWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestWegTestCallWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestWegTestCallWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallWithTextJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallWithTextJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallWithTextJsonResponseSuccess =
  postApiTestWegTestCallWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestWegTestCallWithTextJsonResponseError = (
  | postApiTestWegTestCallWithTextJsonResponse400TextPlain
  | postApiTestWegTestCallWithTextJsonResponse400ApplicationJson
  | postApiTestWegTestCallWithTextJsonResponse400TextJson
  | postApiTestWegTestCallWithTextJsonResponse401TextPlain
  | postApiTestWegTestCallWithTextJsonResponse401ApplicationJson
  | postApiTestWegTestCallWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestWegTestCallWithTextJsonResponse =
  | postApiTestWegTestCallWithTextJsonResponseSuccess
  | postApiTestWegTestCallWithTextJsonResponseError;

export const getPostApiTestWegTestCallWithTextJsonUrl = () => {
  return `/api/Test/WegTestCall`;
};

export const postApiTestWegTestCallWithTextJson = async (
  options?: RequestInit,
): Promise<postApiTestWegTestCallWithTextJsonResponse> => {
  const res = await fetch(getPostApiTestWegTestCallWithTextJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestWegTestCallWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestWegTestCallWithTextJsonResponse;
};

export const getPostApiTestWegTestCallWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestWegTestCallWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestWegTestCallWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTestWegTestCallWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestWegTestCallWithTextJson>>,
    void
  > = () => {
    return postApiTestWegTestCallWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestWegTestCallWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestWegTestCallWithTextJson>>
>;

export type PostApiTestWegTestCallWithTextJsonMutationError = ProblemDetails;

export const usePostApiTestWegTestCallWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestWegTestCallWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestWegTestCallWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestWegTestCallWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestWegTestCallWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestWegTestCallWithApplicationJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestWegTestCallWithApplicationJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallWithApplicationJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestWegTestCallWithApplicationJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallWithApplicationJsonResponseSuccess =
  postApiTestWegTestCallWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestWegTestCallWithApplicationJsonResponseError = (
  | postApiTestWegTestCallWithApplicationJsonResponse400TextPlain
  | postApiTestWegTestCallWithApplicationJsonResponse400ApplicationJson
  | postApiTestWegTestCallWithApplicationJsonResponse400TextJson
  | postApiTestWegTestCallWithApplicationJsonResponse401TextPlain
  | postApiTestWegTestCallWithApplicationJsonResponse401ApplicationJson
  | postApiTestWegTestCallWithApplicationJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestWegTestCallWithApplicationJsonResponse =
  | postApiTestWegTestCallWithApplicationJsonResponseSuccess
  | postApiTestWegTestCallWithApplicationJsonResponseError;

export const getPostApiTestWegTestCallWithApplicationJsonUrl = () => {
  return `/api/Test/WegTestCall`;
};

export const postApiTestWegTestCallWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiTestWegTestCallWithApplicationJsonResponse> => {
  const res = await fetch(getPostApiTestWegTestCallWithApplicationJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestWegTestCallWithApplicationJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestWegTestCallWithApplicationJsonResponse;
};

export const getPostApiTestWegTestCallWithApplicationJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestWegTestCallWithApplicationJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestWegTestCallWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTestWegTestCallWithApplicationJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestWegTestCallWithApplicationJson>>,
    void
  > = () => {
    return postApiTestWegTestCallWithApplicationJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestWegTestCallWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTestWegTestCallWithApplicationJson>>
  >;

export type PostApiTestWegTestCallWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiTestWegTestCallWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestWegTestCallWithApplicationJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestWegTestCallWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestWegTestCallWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type getApiTestGetMockSessionResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestGetMockSessionResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestGetMockSessionResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestGetMockSessionResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestGetMockSessionResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestGetMockSessionResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestGetMockSessionResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestGetMockSessionResponseSuccess =
  getApiTestGetMockSessionResponse200 & {
    headers: Headers;
  };
export type getApiTestGetMockSessionResponseError = (
  | getApiTestGetMockSessionResponse400TextPlain
  | getApiTestGetMockSessionResponse400ApplicationJson
  | getApiTestGetMockSessionResponse400TextJson
  | getApiTestGetMockSessionResponse401TextPlain
  | getApiTestGetMockSessionResponse401ApplicationJson
  | getApiTestGetMockSessionResponse401TextJson
) & {
  headers: Headers;
};

export type getApiTestGetMockSessionResponse =
  | getApiTestGetMockSessionResponseSuccess
  | getApiTestGetMockSessionResponseError;

export const getGetApiTestGetMockSessionUrl = () => {
  return `/api/Test/GetMockSession`;
};

export const getApiTestGetMockSession = async (
  options?: RequestInit,
): Promise<getApiTestGetMockSessionResponse> => {
  const res = await fetch(getGetApiTestGetMockSessionUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiTestGetMockSessionResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestGetMockSessionResponse;
};

export const getGetApiTestGetMockSessionQueryKey = () => {
  return [`/api/Test/GetMockSession`] as const;
};

export const getGetApiTestGetMockSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestGetMockSession>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTestGetMockSessionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestGetMockSession>>
  > = ({ signal }) => getApiTestGetMockSession({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestGetMockSession>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestGetMockSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestGetMockSession>>
>;
export type GetApiTestGetMockSessionQueryError = ProblemDetails;

export function useGetApiTestGetMockSession<
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = ProblemDetails,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestGetMockSession>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestGetMockSession>>,
          TError,
          Awaited<ReturnType<typeof getApiTestGetMockSession>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestGetMockSession<
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestGetMockSession>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestGetMockSession>>,
          TError,
          Awaited<ReturnType<typeof getApiTestGetMockSession>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestGetMockSession<
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestGetMockSession>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestGetMockSession<
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = ProblemDetails,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestGetMockSession>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestGetMockSessionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type postApiTestMockEasySynchronizationWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestMockEasySynchronizationWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestMockEasySynchronizationWithJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestMockEasySynchronizationWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestMockEasySynchronizationWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestMockEasySynchronizationWithJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestMockEasySynchronizationWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestMockEasySynchronizationWithJsonResponseSuccess =
  postApiTestMockEasySynchronizationWithJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestMockEasySynchronizationWithJsonResponseError = (
  | postApiTestMockEasySynchronizationWithJsonResponse400TextPlain
  | postApiTestMockEasySynchronizationWithJsonResponse400ApplicationJson
  | postApiTestMockEasySynchronizationWithJsonResponse400TextJson
  | postApiTestMockEasySynchronizationWithJsonResponse401TextPlain
  | postApiTestMockEasySynchronizationWithJsonResponse401ApplicationJson
  | postApiTestMockEasySynchronizationWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestMockEasySynchronizationWithJsonResponse =
  | postApiTestMockEasySynchronizationWithJsonResponseSuccess
  | postApiTestMockEasySynchronizationWithJsonResponseError;

export const getPostApiTestMockEasySynchronizationWithJsonUrl = () => {
  return `/api/Test/MockEasySynchronization`;
};

export const postApiTestMockEasySynchronizationWithJson = async (
  postApiTestMockEasySynchronizationWithJsonBody: string[],
  options?: RequestInit,
): Promise<postApiTestMockEasySynchronizationWithJsonResponse> => {
  const res = await fetch(getPostApiTestMockEasySynchronizationWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(postApiTestMockEasySynchronizationWithJsonBody),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestMockEasySynchronizationWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestMockEasySynchronizationWithJsonResponse;
};

export const getPostApiTestMockEasySynchronizationWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestMockEasySynchronizationWithJson>>,
    TError,
    { data: string[] },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestMockEasySynchronizationWithJson>>,
  TError,
  { data: string[] },
  TContext
> => {
  const mutationKey = ["postApiTestMockEasySynchronizationWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestMockEasySynchronizationWithJson>>,
    { data: string[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestMockEasySynchronizationWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestMockEasySynchronizationWithJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTestMockEasySynchronizationWithJson>>
  >;
export type PostApiTestMockEasySynchronizationWithJsonMutationBody = string[];
export type PostApiTestMockEasySynchronizationWithJsonMutationError =
  ProblemDetails;

export const usePostApiTestMockEasySynchronizationWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestMockEasySynchronizationWithJson>>,
      TError,
      { data: string[] },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestMockEasySynchronizationWithJson>>,
  TError,
  { data: string[] },
  TContext
> => {
  return useMutation(
    getPostApiTestMockEasySynchronizationWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestMockEasySynchronizationWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestMockEasySynchronizationWithTextJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestMockEasySynchronizationWithTextJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestMockEasySynchronizationWithTextJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestMockEasySynchronizationWithTextJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestMockEasySynchronizationWithTextJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestMockEasySynchronizationWithTextJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestMockEasySynchronizationWithTextJsonResponseSuccess =
  postApiTestMockEasySynchronizationWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestMockEasySynchronizationWithTextJsonResponseError = (
  | postApiTestMockEasySynchronizationWithTextJsonResponse400TextPlain
  | postApiTestMockEasySynchronizationWithTextJsonResponse400ApplicationJson
  | postApiTestMockEasySynchronizationWithTextJsonResponse400TextJson
  | postApiTestMockEasySynchronizationWithTextJsonResponse401TextPlain
  | postApiTestMockEasySynchronizationWithTextJsonResponse401ApplicationJson
  | postApiTestMockEasySynchronizationWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestMockEasySynchronizationWithTextJsonResponse =
  | postApiTestMockEasySynchronizationWithTextJsonResponseSuccess
  | postApiTestMockEasySynchronizationWithTextJsonResponseError;

export const getPostApiTestMockEasySynchronizationWithTextJsonUrl = () => {
  return `/api/Test/MockEasySynchronization`;
};

export const postApiTestMockEasySynchronizationWithTextJson = async (
  options?: RequestInit,
): Promise<postApiTestMockEasySynchronizationWithTextJsonResponse> => {
  const res = await fetch(
    getPostApiTestMockEasySynchronizationWithTextJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestMockEasySynchronizationWithTextJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestMockEasySynchronizationWithTextJsonResponse;
};

export const getPostApiTestMockEasySynchronizationWithTextJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiTestMockEasySynchronizationWithTextJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestMockEasySynchronizationWithTextJson>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiTestMockEasySynchronizationWithTextJson"];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiTestMockEasySynchronizationWithTextJson>
      >,
      void
    > = () => {
      return postApiTestMockEasySynchronizationWithTextJson(fetchOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiTestMockEasySynchronizationWithTextJsonMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTestMockEasySynchronizationWithTextJson>>
  >;

export type PostApiTestMockEasySynchronizationWithTextJsonMutationError =
  ProblemDetails;

export const usePostApiTestMockEasySynchronizationWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiTestMockEasySynchronizationWithTextJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestMockEasySynchronizationWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestMockEasySynchronizationWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestMockEasySynchronizationWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestMockEasySynchronizationWithApplicationJsonResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestMockEasySynchronizationWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestMockEasySynchronizationWithApplicationJsonResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestMockEasySynchronizationWithApplicationJsonResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestMockEasySynchronizationWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestMockEasySynchronizationWithApplicationJsonResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestMockEasySynchronizationWithApplicationJsonResponseSuccess =
  postApiTestMockEasySynchronizationWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestMockEasySynchronizationWithApplicationJsonResponseError =
  (
    | postApiTestMockEasySynchronizationWithApplicationJsonResponse400TextPlain
    | postApiTestMockEasySynchronizationWithApplicationJsonResponse400ApplicationJson
    | postApiTestMockEasySynchronizationWithApplicationJsonResponse400TextJson
    | postApiTestMockEasySynchronizationWithApplicationJsonResponse401TextPlain
    | postApiTestMockEasySynchronizationWithApplicationJsonResponse401ApplicationJson
    | postApiTestMockEasySynchronizationWithApplicationJsonResponse401TextJson
  ) & {
    headers: Headers;
  };

export type postApiTestMockEasySynchronizationWithApplicationJsonResponse =
  | postApiTestMockEasySynchronizationWithApplicationJsonResponseSuccess
  | postApiTestMockEasySynchronizationWithApplicationJsonResponseError;

export const getPostApiTestMockEasySynchronizationWithApplicationJsonUrl =
  () => {
    return `/api/Test/MockEasySynchronization`;
  };

export const postApiTestMockEasySynchronizationWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiTestMockEasySynchronizationWithApplicationJsonResponse> => {
  const res = await fetch(
    getPostApiTestMockEasySynchronizationWithApplicationJsonUrl(),
    {
      ...options,
      method: "POST",
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestMockEasySynchronizationWithApplicationJsonResponse["data"] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestMockEasySynchronizationWithApplicationJsonResponse;
};

export const getPostApiTestMockEasySynchronizationWithApplicationJsonMutationOptions =
  <TError = ProblemDetails, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiTestMockEasySynchronizationWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiTestMockEasySynchronizationWithApplicationJson>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiTestMockEasySynchronizationWithApplicationJson",
    ];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiTestMockEasySynchronizationWithApplicationJson>
      >,
      void
    > = () => {
      return postApiTestMockEasySynchronizationWithApplicationJson(
        fetchOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiTestMockEasySynchronizationWithApplicationJsonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiTestMockEasySynchronizationWithApplicationJson>
    >
  >;

export type PostApiTestMockEasySynchronizationWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiTestMockEasySynchronizationWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiTestMockEasySynchronizationWithApplicationJson>
      >,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiTestMockEasySynchronizationWithApplicationJson>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestMockEasySynchronizationWithApplicationJsonMutationOptions(
      options,
    ),
    queryClient,
  );
};

export type postApiTestTestEmailWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestTestEmailWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailWithJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailWithJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailWithJsonResponseSuccess =
  postApiTestTestEmailWithJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestTestEmailWithJsonResponseError = (
  | postApiTestTestEmailWithJsonResponse400TextPlain
  | postApiTestTestEmailWithJsonResponse400ApplicationJson
  | postApiTestTestEmailWithJsonResponse400TextJson
  | postApiTestTestEmailWithJsonResponse401TextPlain
  | postApiTestTestEmailWithJsonResponse401ApplicationJson
  | postApiTestTestEmailWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestTestEmailWithJsonResponse =
  | postApiTestTestEmailWithJsonResponseSuccess
  | postApiTestTestEmailWithJsonResponseError;

export const getPostApiTestTestEmailWithJsonUrl = () => {
  return `/api/Test/TestEmail`;
};

export const postApiTestTestEmailWithJson = async (
  mailRequest: MailRequest,
  options?: RequestInit,
): Promise<postApiTestTestEmailWithJsonResponse> => {
  const res = await fetch(getPostApiTestTestEmailWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mailRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestTestEmailWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestTestEmailWithJsonResponse;
};

export const getPostApiTestTestEmailWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestTestEmailWithJson>>,
    TError,
    { data: MailRequest },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestTestEmailWithJson>>,
  TError,
  { data: MailRequest },
  TContext
> => {
  const mutationKey = ["postApiTestTestEmailWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestTestEmailWithJson>>,
    { data: MailRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestTestEmailWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestTestEmailWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestTestEmailWithJson>>
>;
export type PostApiTestTestEmailWithJsonMutationBody = MailRequest;
export type PostApiTestTestEmailWithJsonMutationError = ProblemDetails;

export const usePostApiTestTestEmailWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestTestEmailWithJson>>,
      TError,
      { data: MailRequest },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestTestEmailWithJson>>,
  TError,
  { data: MailRequest },
  TContext
> => {
  return useMutation(
    getPostApiTestTestEmailWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestTestEmailWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestTestEmailWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailWithTextJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailWithTextJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailWithTextJsonResponseSuccess =
  postApiTestTestEmailWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestTestEmailWithTextJsonResponseError = (
  | postApiTestTestEmailWithTextJsonResponse400TextPlain
  | postApiTestTestEmailWithTextJsonResponse400ApplicationJson
  | postApiTestTestEmailWithTextJsonResponse400TextJson
  | postApiTestTestEmailWithTextJsonResponse401TextPlain
  | postApiTestTestEmailWithTextJsonResponse401ApplicationJson
  | postApiTestTestEmailWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestTestEmailWithTextJsonResponse =
  | postApiTestTestEmailWithTextJsonResponseSuccess
  | postApiTestTestEmailWithTextJsonResponseError;

export const getPostApiTestTestEmailWithTextJsonUrl = () => {
  return `/api/Test/TestEmail`;
};

export const postApiTestTestEmailWithTextJson = async (
  options?: RequestInit,
): Promise<postApiTestTestEmailWithTextJsonResponse> => {
  const res = await fetch(getPostApiTestTestEmailWithTextJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestTestEmailWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestTestEmailWithTextJsonResponse;
};

export const getPostApiTestTestEmailWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestTestEmailWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestTestEmailWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTestTestEmailWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestTestEmailWithTextJson>>,
    void
  > = () => {
    return postApiTestTestEmailWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestTestEmailWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestTestEmailWithTextJson>>
>;

export type PostApiTestTestEmailWithTextJsonMutationError = ProblemDetails;

export const usePostApiTestTestEmailWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestTestEmailWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestTestEmailWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestTestEmailWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestTestEmailWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestTestEmailWithApplicationJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailWithApplicationJsonResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiTestTestEmailWithApplicationJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailWithApplicationJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailWithApplicationJsonResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiTestTestEmailWithApplicationJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailWithApplicationJsonResponseSuccess =
  postApiTestTestEmailWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestTestEmailWithApplicationJsonResponseError = (
  | postApiTestTestEmailWithApplicationJsonResponse400TextPlain
  | postApiTestTestEmailWithApplicationJsonResponse400ApplicationJson
  | postApiTestTestEmailWithApplicationJsonResponse400TextJson
  | postApiTestTestEmailWithApplicationJsonResponse401TextPlain
  | postApiTestTestEmailWithApplicationJsonResponse401ApplicationJson
  | postApiTestTestEmailWithApplicationJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestTestEmailWithApplicationJsonResponse =
  | postApiTestTestEmailWithApplicationJsonResponseSuccess
  | postApiTestTestEmailWithApplicationJsonResponseError;

export const getPostApiTestTestEmailWithApplicationJsonUrl = () => {
  return `/api/Test/TestEmail`;
};

export const postApiTestTestEmailWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiTestTestEmailWithApplicationJsonResponse> => {
  const res = await fetch(getPostApiTestTestEmailWithApplicationJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestTestEmailWithApplicationJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestTestEmailWithApplicationJsonResponse;
};

export const getPostApiTestTestEmailWithApplicationJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestTestEmailWithApplicationJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestTestEmailWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTestTestEmailWithApplicationJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestTestEmailWithApplicationJson>>,
    void
  > = () => {
    return postApiTestTestEmailWithApplicationJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestTestEmailWithApplicationJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestTestEmailWithApplicationJson>>
>;

export type PostApiTestTestEmailWithApplicationJsonMutationError =
  ProblemDetails;

export const usePostApiTestTestEmailWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestTestEmailWithApplicationJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestTestEmailWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestTestEmailWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestTestWithJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestTestWithJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestWithJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestWithJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestWithJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestWithJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestWithJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestWithJsonResponseSuccess =
  postApiTestTestWithJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestTestWithJsonResponseError = (
  | postApiTestTestWithJsonResponse400TextPlain
  | postApiTestTestWithJsonResponse400ApplicationJson
  | postApiTestTestWithJsonResponse400TextJson
  | postApiTestTestWithJsonResponse401TextPlain
  | postApiTestTestWithJsonResponse401ApplicationJson
  | postApiTestTestWithJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestTestWithJsonResponse =
  postApiTestTestWithJsonResponseSuccess | postApiTestTestWithJsonResponseError;

export const getPostApiTestTestWithJsonUrl = () => {
  return `/api/Test/Test`;
};

export const postApiTestTestWithJson = async (
  postApiTestTestWithJsonBody: string[],
  options?: RequestInit,
): Promise<postApiTestTestWithJsonResponse> => {
  const res = await fetch(getPostApiTestTestWithJsonUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(postApiTestTestWithJsonBody),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestTestWithJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestTestWithJsonResponse;
};

export const getPostApiTestTestWithJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestTestWithJson>>,
    TError,
    { data: string[] },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestTestWithJson>>,
  TError,
  { data: string[] },
  TContext
> => {
  const mutationKey = ["postApiTestTestWithJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestTestWithJson>>,
    { data: string[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestTestWithJson(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestTestWithJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestTestWithJson>>
>;
export type PostApiTestTestWithJsonMutationBody = string[];
export type PostApiTestTestWithJsonMutationError = ProblemDetails;

export const usePostApiTestTestWithJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestTestWithJson>>,
      TError,
      { data: string[] },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestTestWithJson>>,
  TError,
  { data: string[] },
  TContext
> => {
  return useMutation(
    getPostApiTestTestWithJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestTestWithTextJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestTestWithTextJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestWithTextJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestWithTextJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestWithTextJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestWithTextJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestWithTextJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestWithTextJsonResponseSuccess =
  postApiTestTestWithTextJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestTestWithTextJsonResponseError = (
  | postApiTestTestWithTextJsonResponse400TextPlain
  | postApiTestTestWithTextJsonResponse400ApplicationJson
  | postApiTestTestWithTextJsonResponse400TextJson
  | postApiTestTestWithTextJsonResponse401TextPlain
  | postApiTestTestWithTextJsonResponse401ApplicationJson
  | postApiTestTestWithTextJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestTestWithTextJsonResponse =
  | postApiTestTestWithTextJsonResponseSuccess
  | postApiTestTestWithTextJsonResponseError;

export const getPostApiTestTestWithTextJsonUrl = () => {
  return `/api/Test/Test`;
};

export const postApiTestTestWithTextJson = async (
  options?: RequestInit,
): Promise<postApiTestTestWithTextJsonResponse> => {
  const res = await fetch(getPostApiTestTestWithTextJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestTestWithTextJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestTestWithTextJsonResponse;
};

export const getPostApiTestTestWithTextJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestTestWithTextJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestTestWithTextJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTestTestWithTextJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestTestWithTextJson>>,
    void
  > = () => {
    return postApiTestTestWithTextJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestTestWithTextJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestTestWithTextJson>>
>;

export type PostApiTestTestWithTextJsonMutationError = ProblemDetails;

export const usePostApiTestTestWithTextJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestTestWithTextJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestTestWithTextJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestTestWithTextJsonMutationOptions(options),
    queryClient,
  );
};

export type postApiTestTestWithApplicationJsonResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestTestWithApplicationJsonResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestWithApplicationJsonResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestWithApplicationJsonResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestWithApplicationJsonResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestWithApplicationJsonResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestWithApplicationJsonResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestWithApplicationJsonResponseSuccess =
  postApiTestTestWithApplicationJsonResponse200 & {
    headers: Headers;
  };
export type postApiTestTestWithApplicationJsonResponseError = (
  | postApiTestTestWithApplicationJsonResponse400TextPlain
  | postApiTestTestWithApplicationJsonResponse400ApplicationJson
  | postApiTestTestWithApplicationJsonResponse400TextJson
  | postApiTestTestWithApplicationJsonResponse401TextPlain
  | postApiTestTestWithApplicationJsonResponse401ApplicationJson
  | postApiTestTestWithApplicationJsonResponse401TextJson
) & {
  headers: Headers;
};

export type postApiTestTestWithApplicationJsonResponse =
  | postApiTestTestWithApplicationJsonResponseSuccess
  | postApiTestTestWithApplicationJsonResponseError;

export const getPostApiTestTestWithApplicationJsonUrl = () => {
  return `/api/Test/Test`;
};

export const postApiTestTestWithApplicationJson = async (
  options?: RequestInit,
): Promise<postApiTestTestWithApplicationJsonResponse> => {
  const res = await fetch(getPostApiTestTestWithApplicationJsonUrl(), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postApiTestTestWithApplicationJsonResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestTestWithApplicationJsonResponse;
};

export const getPostApiTestTestWithApplicationJsonMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestTestWithApplicationJson>>,
    TError,
    void,
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestTestWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTestTestWithApplicationJson"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestTestWithApplicationJson>>,
    void
  > = () => {
    return postApiTestTestWithApplicationJson(fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestTestWithApplicationJsonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestTestWithApplicationJson>>
>;

export type PostApiTestTestWithApplicationJsonMutationError = ProblemDetails;

export const usePostApiTestTestWithApplicationJson = <
  TError = ProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestTestWithApplicationJson>>,
      TError,
      void,
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestTestWithApplicationJson>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTestTestWithApplicationJsonMutationOptions(options),
    queryClient,
  );
};

export type getApiTestSimulateErrorResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestSimulateErrorResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestSimulateErrorResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestSimulateErrorResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestSimulateErrorResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestSimulateErrorResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestSimulateErrorResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestSimulateErrorResponse403TextPlain = {
  data: ProblemDetails;
  status: 403;
};

export type getApiTestSimulateErrorResponse403ApplicationJson = {
  data: ProblemDetails;
  status: 403;
};

export type getApiTestSimulateErrorResponse403TextJson = {
  data: ProblemDetails;
  status: 403;
};

export type getApiTestSimulateErrorResponse404TextPlain = {
  data: ProblemDetails;
  status: 404;
};

export type getApiTestSimulateErrorResponse404ApplicationJson = {
  data: ProblemDetails;
  status: 404;
};

export type getApiTestSimulateErrorResponse404TextJson = {
  data: ProblemDetails;
  status: 404;
};

export type getApiTestSimulateErrorResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type getApiTestSimulateErrorResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type getApiTestSimulateErrorResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type getApiTestSimulateErrorResponse422TextPlain = {
  data: ProblemDetails;
  status: 422;
};

export type getApiTestSimulateErrorResponse422ApplicationJson = {
  data: ProblemDetails;
  status: 422;
};

export type getApiTestSimulateErrorResponse422TextJson = {
  data: ProblemDetails;
  status: 422;
};

export type getApiTestSimulateErrorResponse429TextPlain = {
  data: ProblemDetails;
  status: 429;
};

export type getApiTestSimulateErrorResponse429ApplicationJson = {
  data: ProblemDetails;
  status: 429;
};

export type getApiTestSimulateErrorResponse429TextJson = {
  data: ProblemDetails;
  status: 429;
};

export type getApiTestSimulateErrorResponse500 = {
  data: void;
  status: 500;
};

export type getApiTestSimulateErrorResponse502 = {
  data: void;
  status: 502;
};

export type getApiTestSimulateErrorResponse503 = {
  data: void;
  status: 503;
};

export type getApiTestSimulateErrorResponseSuccess =
  getApiTestSimulateErrorResponse200 & {
    headers: Headers;
  };
export type getApiTestSimulateErrorResponseError = (
  | getApiTestSimulateErrorResponse400TextPlain
  | getApiTestSimulateErrorResponse400ApplicationJson
  | getApiTestSimulateErrorResponse400TextJson
  | getApiTestSimulateErrorResponse401TextPlain
  | getApiTestSimulateErrorResponse401ApplicationJson
  | getApiTestSimulateErrorResponse401TextJson
  | getApiTestSimulateErrorResponse403TextPlain
  | getApiTestSimulateErrorResponse403ApplicationJson
  | getApiTestSimulateErrorResponse403TextJson
  | getApiTestSimulateErrorResponse404TextPlain
  | getApiTestSimulateErrorResponse404ApplicationJson
  | getApiTestSimulateErrorResponse404TextJson
  | getApiTestSimulateErrorResponse409TextPlain
  | getApiTestSimulateErrorResponse409ApplicationJson
  | getApiTestSimulateErrorResponse409TextJson
  | getApiTestSimulateErrorResponse422TextPlain
  | getApiTestSimulateErrorResponse422ApplicationJson
  | getApiTestSimulateErrorResponse422TextJson
  | getApiTestSimulateErrorResponse429TextPlain
  | getApiTestSimulateErrorResponse429ApplicationJson
  | getApiTestSimulateErrorResponse429TextJson
  | getApiTestSimulateErrorResponse500
  | getApiTestSimulateErrorResponse502
  | getApiTestSimulateErrorResponse503
) & {
  headers: Headers;
};

export type getApiTestSimulateErrorResponse =
  getApiTestSimulateErrorResponseSuccess | getApiTestSimulateErrorResponseError;

export const getGetApiTestSimulateErrorUrl = (
  params?: GetApiTestSimulateErrorParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/Test/SimulateError?${stringifiedParams}`
    : `/api/Test/SimulateError`;
};

export const getApiTestSimulateError = async (
  params?: GetApiTestSimulateErrorParams,
  options?: RequestInit,
): Promise<getApiTestSimulateErrorResponse> => {
  const res = await fetch(getGetApiTestSimulateErrorUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiTestSimulateErrorResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestSimulateErrorResponse;
};

export const getGetApiTestSimulateErrorQueryKey = (
  params?: GetApiTestSimulateErrorParams,
) => {
  return [`/api/Test/SimulateError`, ...(params ? [params] : [])] as const;
};

export const getGetApiTestSimulateErrorQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = ProblemDetails | void,
>(
  params?: GetApiTestSimulateErrorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTestSimulateErrorQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestSimulateError>>
  > = ({ signal }) =>
    getApiTestSimulateError(params, { signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestSimulateError>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestSimulateErrorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestSimulateError>>
>;
export type GetApiTestSimulateErrorQueryError = ProblemDetails | void;

export function useGetApiTestSimulateError<
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = ProblemDetails | void,
>(
  params: undefined | GetApiTestSimulateErrorParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestSimulateError>>,
          TError,
          Awaited<ReturnType<typeof getApiTestSimulateError>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestSimulateError<
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = ProblemDetails | void,
>(
  params?: GetApiTestSimulateErrorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestSimulateError>>,
          TError,
          Awaited<ReturnType<typeof getApiTestSimulateError>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestSimulateError<
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = ProblemDetails | void,
>(
  params?: GetApiTestSimulateErrorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestSimulateError<
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = ProblemDetails | void,
>(
  params?: GetApiTestSimulateErrorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestSimulateErrorQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getApiTestMultiplyDBEntrysResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestMultiplyDBEntrysResponseSuccess =
  getApiTestMultiplyDBEntrysResponse200 & {
    headers: Headers;
  };
export type getApiTestMultiplyDBEntrysResponse =
  getApiTestMultiplyDBEntrysResponseSuccess;

export const getGetApiTestMultiplyDBEntrysUrl = () => {
  return `/api/Test/MultiplyDBEntrys`;
};

export const getApiTestMultiplyDBEntrys = async (
  options?: RequestInit,
): Promise<getApiTestMultiplyDBEntrysResponse> => {
  const res = await fetch(getGetApiTestMultiplyDBEntrysUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getApiTestMultiplyDBEntrysResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestMultiplyDBEntrysResponse;
};

export const getGetApiTestMultiplyDBEntrysQueryKey = () => {
  return [`/api/Test/MultiplyDBEntrys`] as const;
};

export const getGetApiTestMultiplyDBEntrysQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTestMultiplyDBEntrysQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>
  > = ({ signal }) => getApiTestMultiplyDBEntrys({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestMultiplyDBEntrysQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>
>;
export type GetApiTestMultiplyDBEntrysQueryError = unknown;

export function useGetApiTestMultiplyDBEntrys<
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
          TError,
          Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestMultiplyDBEntrys<
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
          TError,
          Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestMultiplyDBEntrys<
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestMultiplyDBEntrys<
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestMultiplyDBEntrysQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
